import type { AllKnownFestinaEnumsRecord as CollCalcEnumRecord } from "@festina/collcalc-general-types/collcalc"
import type { AllKnownFestinaEnumsRecord as DatamartEnumRecord } from "@festina/datamart-general-types/datamart"
import type { AllKnownFestinaEnumsRecord as Datamart2EnumRecord } from "@festina/datamart2-general-types/datamart2"
import type { AllKnownFestinaEnumsRecord as LegalEntityEnumRecord } from "@festina/legalentity-general-types/legalentity"
import type { AllKnownFestinaEnumsRecord as LifeEnumRecord } from "@festina/life-general-types/life"
import type { AllKnownFestinaEnumsRecord as MoneyInEnumRecord } from "@festina/moneyin-general-types/moneyin"
import type { AllKnownFestinaEnumsRecord as MoneyOutEnumRecord } from "@festina/moneyout-general-types/moneyout"
import type { AllKnownFestinaEnumsRecord as UnitLinkEnumRecord } from "@festina/unitlink-general-types/unitlink"
import type { Components } from "@festina-life/api"
import { defineTranslations, type ExtendableTranslationEnumRecords, type LayerTranslationEnumRecords } from "@festina-life/core"

export const enEnums = defineTranslations<
  LayerTranslationEnumRecords<
    {
      collCalc: [CollCalcEnumRecord, unknown]
      life: [LifeEnumRecord, unknown]
      legalEntity: [LegalEntityEnumRecord, unknown]
      moneyIn: [MoneyInEnumRecord, unknown]
      moneyOut: [MoneyOutEnumRecord, unknown]
      unitLink: [UnitLinkEnumRecord, unknown]
      dataMart: [DatamartEnumRecord, unknown]
      dataMart2: [Datamart2EnumRecord, unknown]
    },
    Components
  >
>()({
  "collCalc.enum.AccountType.none": "None",
  "collCalc.enum.AccountType.rounding": "",
  "collCalc.enum.BatchStatusType.completed": "",
  "collCalc.enum.BatchStatusType.created": "",
  "collCalc.enum.BatchStatusType.failed": "",
  "collCalc.enum.BatchStatusType.started": "",
  "collCalc.enum.BatchStatusType.stopped": "",
  "collCalc.enum.BulkDataType.Accounts": "",
  "collCalc.enum.BulkDataType.BalancePostings": "",
  "collCalc.enum.BulkDataType.Enums": "",
  "collCalc.enum.BulkDataType.OpenPostPostings": "",
  "collCalc.enum.BulkDataType.ParameterValueIntervals": "",
  "collCalc.enum.BulkDataType.ParameterValues": "",
  "collCalc.enum.BulkDataType.TariffTemplates": "",
  "collCalc.enum.BulkDataType.Tenants": "",
  "collCalc.enum.BulkDataType.WorkPads": "",
  "collCalc.enum.BusinessType.company": "",
  "collCalc.enum.BusinessType.person": "",
  "collCalc.enum.CcCalcType.monthly": "Monthly",
  "collCalc.enum.CcCalcType.yearly": "Yearly",
  "collCalc.enum.CcGroupType.ageMonths": "",
  "collCalc.enum.CcGroupType.ageYears": "",
  "collCalc.enum.CcInputType.x": "",
  "collCalc.enum.CcStateStatus.calculated": "Calculated",
  "collCalc.enum.CcStateStatus.failed": "Failed",
  "collCalc.enum.CcStateStatus.invalid": "Invalid",
  "collCalc.enum.CcStateStatus.succeeded": "Succeeded",
  "collCalc.enum.CcStateStatus.superseded": "Superseded",
  "collCalc.enum.CcStateStatus.waiting": "Waiting",
  "collCalc.enum.CommandGroupType.advance": "",
  "collCalc.enum.CommandGroupType.annotation": "",
  "collCalc.enum.CommandGroupType.calculation": "",
  "collCalc.enum.CommandGroupType.employerAgreement": "",
  "collCalc.enum.CommandGroupType.employment": "",
  "collCalc.enum.CommandGroupType.legalEntity": "",
  "collCalc.enum.CommandGroupType.moneyIn": "",
  "collCalc.enum.CommandGroupType.moneyOut": "",
  "collCalc.enum.CommandGroupType.none": "",
  "collCalc.enum.CommandGroupType.policyChange": "",
  "collCalc.enum.CommandGroupType.posting": "",
  "collCalc.enum.CommandGroupType.tax": "",
  "collCalc.enum.CommandGroupType.unitlink": "",
  "collCalc.enum.CommandType.addAccessGroupAnnotation": "",
  "collCalc.enum.CommandType.amendAccessGroupAnnotation": "",
  "collCalc.enum.CommandType.defaultTemplate": "",
  "collCalc.enum.CommandType.removeAccessGroupAnnotation": "",
  "collCalc.enum.ConfigurationEntityType.EnumDefinition": "",
  "collCalc.enum.ConfigurationEntityType.EnumLiteral": "",
  "collCalc.enum.ConfigurationEntityType.GlMap": "",
  "collCalc.enum.ConfigurationEntityType.ParameterDefinition": "",
  "collCalc.enum.ConfigurationEntityType.ParameterValue": "",
  "collCalc.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "collCalc.enum.ConfigurationEntityType.RegisteredTenant": "",
  "collCalc.enum.ConfigurationEntityType.Template": "",
  "collCalc.enum.DataSubscriptionRoleType.unspecified": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.deleted": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.processed": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.registered": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.rejected": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.sent": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.unsent": "",
  "collCalc.enum.ExternalPayloadReceiver.collcalc": "",
  "collCalc.enum.ExternalPayloadReceiver.datamart2": "",
  "collCalc.enum.ExternalPayloadReceiver.external": "",
  "collCalc.enum.ExternalPayloadReceiver.legalentity": "",
  "collCalc.enum.ExternalPayloadReceiver.life": "",
  "collCalc.enum.ExternalPayloadReceiver.moneyin": "",
  "collCalc.enum.ExternalPayloadReceiver.moneyout": "",
  "collCalc.enum.ExternalPayloadReceiver.unitlink": "",
  "collCalc.enum.ExternalPayloadType.bulkDataExport": "",
  "collCalc.enum.ExternalPayloadType.camt53": "camt.053",
  "collCalc.enum.ExternalPayloadType.camt53Returns": "camt.053 retour",
  "collCalc.enum.ExternalPayloadType.camt54": "camt.054",
  "collCalc.enum.ExternalPayloadType.generalLedger": "",
  "collCalc.enum.ExternalPayloadType.migration": "",
  "collCalc.enum.ExternalPayloadType.namingResponse": "",
  "collCalc.enum.ExternalPayloadType.none": "None",
  "collCalc.enum.ExternalPayloadType.pain001": "pain.001",
  "collCalc.enum.ExternalPayloadType.pain002": "pain.002",
  "collCalc.enum.ExternalPayloadType.testTransactionalIn": "",
  "collCalc.enum.ExternalPayloadType.testTransactionalOut": "",
  "collCalc.enum.ExternalPayloadType.testin": "",
  "collCalc.enum.ExternalPayloadType.testout": "",
  "collCalc.enum.FPlusCompletionItemTag.deprecated": "",
  "collCalc.enum.Gender.Female": "",
  "collCalc.enum.Gender.Male": "",
  "collCalc.enum.Gender.Unknown": "",
  "collCalc.enum.GlAggregationType.correction": "",
  "collCalc.enum.GlAggregationType.counter": "",
  "collCalc.enum.GlAggregationType.manual": "",
  "collCalc.enum.GlAggregationType.normal": "",
  "collCalc.enum.LogLevel.all": "",
  "collCalc.enum.LogLevel.debug": "",
  "collCalc.enum.LogLevel.error": "",
  "collCalc.enum.LogLevel.info": "",
  "collCalc.enum.LogLevel.off": "",
  "collCalc.enum.LogLevel.trace": "",
  "collCalc.enum.LogLevel.warn": "",
  "collCalc.enum.MetaAssociationOutput.aggregation": "",
  "collCalc.enum.MetaAssociationOutput.composition": "",
  "collCalc.enum.MetaCardinalityOutput.many": "",
  "collCalc.enum.MetaCardinalityOutput.one": "",
  "collCalc.enum.PostingTable.BP": "",
  "collCalc.enum.PostingTable.OPP": "",
  "collCalc.enum.PostingType.glRounding": "",
  "collCalc.enum.PostingType.glRoundingExcluded": "",
  "collCalc.enum.PostingType.none": "None",
  "collCalc.enum.ReportType.none": "None",
  "collCalc.enum.ReportingEventType.cancelled": "",
  "collCalc.enum.ReportingEventType.newReport": "",
  "collCalc.enum.ReportingEventType.reported": "",
  "collCalc.enum.ReportingEventType.update": "",
  "collCalc.enum.Step.x": "",
  "collCalc.enum.StepValueType.number": "",
  "collCalc.enum.StepValueType.percent": "",
  "collCalc.enum.TenantSubGroup.none": "None",
  "collCalc.enum.TestBatchSpecificationType.faulty": "",
  "collCalc.enum.TestBatchSpecificationType.noop": "",
  "collCalc.enum.TestBatchSpecificationType.normal": "",
  "dataMart.enum.AccountType.none": "",
  "dataMart.enum.BatchStatusType.completed": "",
  "dataMart.enum.BatchStatusType.created": "",
  "dataMart.enum.BatchStatusType.failed": "",
  "dataMart.enum.BatchStatusType.started": "",
  "dataMart.enum.BatchStatusType.stopped": "",
  "dataMart.enum.ConfigurationEntityType.EnumDefinition": "",
  "dataMart.enum.ConfigurationEntityType.EnumLiteral": "",
  "dataMart.enum.ConfigurationEntityType.GlMap": "",
  "dataMart.enum.ConfigurationEntityType.ParameterDefinition": "",
  "dataMart.enum.ConfigurationEntityType.ParameterValue": "",
  "dataMart.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "dataMart.enum.ConfigurationEntityType.RegisteredTenant": "",
  "dataMart.enum.ConfigurationEntityType.Template": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.deleted": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.processed": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.registered": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.rejected": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.sent": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.unsent": "",
  "dataMart.enum.ExternalPayloadReceiver.external": "",
  "dataMart.enum.ExternalPayloadType.generalLedger": "",
  "dataMart.enum.ExternalPayloadType.none": "",
  "dataMart.enum.ExternalPayloadType.testTransactionalIn": "",
  "dataMart.enum.ExternalPayloadType.testTransactionalOut": "",
  "dataMart.enum.ExternalPayloadType.testin": "",
  "dataMart.enum.ExternalPayloadType.testout": "",
  "dataMart.enum.FPlusCompletionItemTag.deprecated": "",
  "dataMart.enum.GlAggregationType.correction": "",
  "dataMart.enum.GlAggregationType.counter": "",
  "dataMart.enum.GlAggregationType.manual": "",
  "dataMart.enum.GlAggregationType.normal": "",
  "dataMart.enum.LogLevel.all": "",
  "dataMart.enum.LogLevel.debug": "",
  "dataMart.enum.LogLevel.error": "",
  "dataMart.enum.LogLevel.info": "",
  "dataMart.enum.LogLevel.off": "",
  "dataMart.enum.LogLevel.trace": "",
  "dataMart.enum.LogLevel.warn": "",
  "dataMart.enum.MetaAssociationOutput.aggregation": "",
  "dataMart.enum.MetaAssociationOutput.composition": "",
  "dataMart.enum.MetaCardinalityOutput.many": "",
  "dataMart.enum.MetaCardinalityOutput.one": "",
  "dataMart.enum.PostingTable.BP": "",
  "dataMart.enum.PostingTable.OPP": "",
  "dataMart.enum.PostingType.none": "",
  "dataMart.enum.TestBatchSpecificationType.faulty": "",
  "dataMart.enum.TestBatchSpecificationType.noop": "",
  "dataMart.enum.TestBatchSpecificationType.normal": "",
  "dataMart2.enum.AccountType.none": "",
  "dataMart2.enum.AccountType.rounding": "",
  "dataMart2.enum.BatchStatusType.completed": "",
  "dataMart2.enum.BatchStatusType.created": "",
  "dataMart2.enum.BatchStatusType.failed": "",
  "dataMart2.enum.BatchStatusType.started": "",
  "dataMart2.enum.BatchStatusType.stopped": "",
  "dataMart2.enum.BulkDataType.Accounts": "",
  "dataMart2.enum.BulkDataType.BalancePostings": "",
  "dataMart2.enum.BulkDataType.Enums": "",
  "dataMart2.enum.BulkDataType.OpenPostPostings": "",
  "dataMart2.enum.BulkDataType.ParameterValueIntervals": "",
  "dataMart2.enum.BulkDataType.ParameterValues": "",
  "dataMart2.enum.BulkDataType.TariffTemplates": "",
  "dataMart2.enum.BulkDataType.Tenants": "",
  "dataMart2.enum.BulkDataType.WorkPads": "",
  "dataMart2.enum.BusinessType.company": "",
  "dataMart2.enum.BusinessType.person": "",
  "dataMart2.enum.CommandGroupType.advance": "",
  "dataMart2.enum.CommandGroupType.annotation": "",
  "dataMart2.enum.CommandGroupType.calculation": "",
  "dataMart2.enum.CommandGroupType.employerAgreement": "",
  "dataMart2.enum.CommandGroupType.employment": "",
  "dataMart2.enum.CommandGroupType.legalEntity": "",
  "dataMart2.enum.CommandGroupType.moneyIn": "",
  "dataMart2.enum.CommandGroupType.moneyOut": "",
  "dataMart2.enum.CommandGroupType.none": "",
  "dataMart2.enum.CommandGroupType.policyChange": "",
  "dataMart2.enum.CommandGroupType.posting": "",
  "dataMart2.enum.CommandGroupType.tax": "",
  "dataMart2.enum.CommandGroupType.unitlink": "",
  "dataMart2.enum.CommandType.addAccessGroupAnnotation": "",
  "dataMart2.enum.CommandType.amendAccessGroupAnnotation": "",
  "dataMart2.enum.CommandType.defaultTemplate": "",
  "dataMart2.enum.CommandType.removeAccessGroupAnnotation": "",
  "dataMart2.enum.ConfigurationEntityType.EnumDefinition": "",
  "dataMart2.enum.ConfigurationEntityType.EnumLiteral": "",
  "dataMart2.enum.ConfigurationEntityType.GlMap": "",
  "dataMart2.enum.ConfigurationEntityType.ParameterDefinition": "",
  "dataMart2.enum.ConfigurationEntityType.ParameterValue": "",
  "dataMart2.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "dataMart2.enum.ConfigurationEntityType.RegisteredTenant": "",
  "dataMart2.enum.ConfigurationEntityType.Template": "",
  "dataMart2.enum.DataSubscriptionRoleType.unspecified": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.deleted": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.processed": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.registered": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.rejected": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.sent": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.unsent": "",
  "dataMart2.enum.ExternalPayloadReceiver.collcalc": "",
  "dataMart2.enum.ExternalPayloadReceiver.datamart2": "",
  "dataMart2.enum.ExternalPayloadReceiver.external": "",
  "dataMart2.enum.ExternalPayloadReceiver.legalentity": "",
  "dataMart2.enum.ExternalPayloadReceiver.life": "",
  "dataMart2.enum.ExternalPayloadReceiver.moneyin": "",
  "dataMart2.enum.ExternalPayloadReceiver.moneyout": "",
  "dataMart2.enum.ExternalPayloadReceiver.unitlink": "",
  "dataMart2.enum.ExternalPayloadType.bulkDataExport": "",
  "dataMart2.enum.ExternalPayloadType.camt53": "",
  "dataMart2.enum.ExternalPayloadType.camt53Returns": "",
  "dataMart2.enum.ExternalPayloadType.camt54": "",
  "dataMart2.enum.ExternalPayloadType.generalLedger": "",
  "dataMart2.enum.ExternalPayloadType.migration": "",
  "dataMart2.enum.ExternalPayloadType.namingResponse": "",
  "dataMart2.enum.ExternalPayloadType.none": "",
  "dataMart2.enum.ExternalPayloadType.pain001": "",
  "dataMart2.enum.ExternalPayloadType.pain002": "",
  "dataMart2.enum.ExternalPayloadType.testTransactionalIn": "",
  "dataMart2.enum.ExternalPayloadType.testTransactionalOut": "",
  "dataMart2.enum.ExternalPayloadType.testin": "",
  "dataMart2.enum.ExternalPayloadType.testout": "",
  "dataMart2.enum.FPlusCompletionItemTag.deprecated": "",
  "dataMart2.enum.Gender.Female": "",
  "dataMart2.enum.Gender.Male": "",
  "dataMart2.enum.Gender.Unknown": "",
  "dataMart2.enum.GlAggregationType.correction": "",
  "dataMart2.enum.GlAggregationType.counter": "",
  "dataMart2.enum.GlAggregationType.manual": "",
  "dataMart2.enum.GlAggregationType.normal": "",
  "dataMart2.enum.LogLevel.all": "",
  "dataMart2.enum.LogLevel.debug": "",
  "dataMart2.enum.LogLevel.error": "",
  "dataMart2.enum.LogLevel.info": "",
  "dataMart2.enum.LogLevel.off": "",
  "dataMart2.enum.LogLevel.trace": "",
  "dataMart2.enum.LogLevel.warn": "",
  "dataMart2.enum.MetaAssociationOutput.aggregation": "",
  "dataMart2.enum.MetaAssociationOutput.composition": "",
  "dataMart2.enum.MetaCardinalityOutput.many": "",
  "dataMart2.enum.MetaCardinalityOutput.one": "",
  "dataMart2.enum.PostingTable.BP": "",
  "dataMart2.enum.PostingTable.OPP": "",
  "dataMart2.enum.PostingType.glRounding": "",
  "dataMart2.enum.PostingType.glRoundingExcluded": "",
  "dataMart2.enum.PostingType.none": "",
  "dataMart2.enum.ReconciliationResultStatus.ACCEPTED": "",
  "dataMart2.enum.ReconciliationResultStatus.MATCH": "",
  "dataMart2.enum.ReconciliationResultStatus.MISMATCH": "",
  "dataMart2.enum.ReconciliationResultStatus.PENDING": "",
  "dataMart2.enum.ReportType.none": "",
  "dataMart2.enum.ReportingEventType.cancelled": "",
  "dataMart2.enum.ReportingEventType.newReport": "",
  "dataMart2.enum.ReportingEventType.reported": "",
  "dataMart2.enum.ReportingEventType.update": "",
  "dataMart2.enum.TestBatchSpecificationType.faulty": "",
  "dataMart2.enum.TestBatchSpecificationType.noop": "",
  "dataMart2.enum.TestBatchSpecificationType.normal": "",
  "legalEntity.enum.AccountType.none": "None",
  "legalEntity.enum.AccountType.rounding": "",
  "legalEntity.enum.AddressType.formal": "Formal",
  "legalEntity.enum.AddressType.informal": "Informal",
  "legalEntity.enum.AddressTypeMigrationV1Data.formal": "",
  "legalEntity.enum.AddressTypeMigrationV1Data.informal": "",
  "legalEntity.enum.BatchStatusType.completed": "Completed",
  "legalEntity.enum.BatchStatusType.created": "Created",
  "legalEntity.enum.BatchStatusType.failed": "Failed",
  "legalEntity.enum.BatchStatusType.started": "Started",
  "legalEntity.enum.BatchStatusType.stopped": "Stopped",
  "legalEntity.enum.BulkDataType.Accounts": "",
  "legalEntity.enum.BulkDataType.BalancePostings": "",
  "legalEntity.enum.BulkDataType.Enums": "",
  "legalEntity.enum.BulkDataType.OpenPostPostings": "",
  "legalEntity.enum.BulkDataType.ParameterValueIntervals": "",
  "legalEntity.enum.BulkDataType.ParameterValues": "",
  "legalEntity.enum.BulkDataType.TariffTemplates": "",
  "legalEntity.enum.BulkDataType.Tenants": "",
  "legalEntity.enum.BulkDataType.WorkPads": "",
  "legalEntity.enum.BusinessType.company": "",
  "legalEntity.enum.BusinessType.person": "",
  "legalEntity.enum.CommandGroupType.advance": "Advance",
  "legalEntity.enum.CommandGroupType.annotation": "Annotation",
  "legalEntity.enum.CommandGroupType.calculation": "Calculation",
  "legalEntity.enum.CommandGroupType.employerAgreement": "Employer agreement",
  "legalEntity.enum.CommandGroupType.employment": "Employment",
  "legalEntity.enum.CommandGroupType.legalEntity": "Legal entity",
  "legalEntity.enum.CommandGroupType.moneyIn": "Money in",
  "legalEntity.enum.CommandGroupType.moneyOut": "Money out",
  "legalEntity.enum.CommandGroupType.none": "None",
  "legalEntity.enum.CommandGroupType.policyChange": "Policy change",
  "legalEntity.enum.CommandGroupType.posting": "Posting",
  "legalEntity.enum.CommandGroupType.tax": "Tax",
  "legalEntity.enum.CommandGroupType.unitlink": "Unitlink",
  "legalEntity.enum.CommandType.addAccessGroupAnnotation": "Add access group annotation",
  "legalEntity.enum.CommandType.addEmployeeName": "Add employee name",
  "legalEntity.enum.CommandType.addressChange": "Address change",
  "legalEntity.enum.CommandType.amendAccessGroupAnnotation": "Amend access group annotation",
  "legalEntity.enum.CommandType.birthDateChange": "Birth date change",
  "legalEntity.enum.CommandType.changeLegalEntity": "Change legal entity",
  "legalEntity.enum.CommandType.companyExternalIdChange": "Company external ID change",
  "legalEntity.enum.CommandType.createCompany": "Create company",
  "legalEntity.enum.CommandType.createMigrationPartnerV3": "Create migration partner",
  "legalEntity.enum.CommandType.createMigrationPartnerV4": "Create migration partner",
  "legalEntity.enum.CommandType.createMigrationPartnersV2": "Create migration partners",
  "legalEntity.enum.CommandType.createPerson": "Create person",
  "legalEntity.enum.CommandType.createPersonMigrationV3": "Create person migration",
  "legalEntity.enum.CommandType.createPersonMigrationV4": "Create person migration",
  "legalEntity.enum.CommandType.createPersonMigrationV5": "Create person migration",
  "legalEntity.enum.CommandType.defaultTemplate": "Default template",
  "legalEntity.enum.CommandType.deleteAddress": "Delete address",
  "legalEntity.enum.CommandType.endPartnership": "End partnership",
  "legalEntity.enum.CommandType.externalIdChange": "External ID change",
  "legalEntity.enum.CommandType.genderChange": "Gender change",
  "legalEntity.enum.CommandType.partnerBirthdateChange": "Partner birthdate change",
  "legalEntity.enum.CommandType.partnerDeceased": "Partner deceased",
  "legalEntity.enum.CommandType.partnerIdChange": "Partner ID change",
  "legalEntity.enum.CommandType.partnerNameChange": "Partner name change",
  "legalEntity.enum.CommandType.personDeceased": "Person deceased",
  "legalEntity.enum.CommandType.personNameChange": "Person name change",
  "legalEntity.enum.CommandType.personRelocation": "Person relocation",
  "legalEntity.enum.CommandType.pointOfContactChange": "Point of contact change",
  "legalEntity.enum.CommandType.removeAccessGroupAnnotation": "Remove access group annotation",
  "legalEntity.enum.CommandType.rollback": "Rollback",
  "legalEntity.enum.CommandType.setPersonState": "Set person state",
  "legalEntity.enum.CommandType.singleAddressChange": "Single address change",
  "legalEntity.enum.CommandType.startPartnership": "Start partnership",
  "legalEntity.enum.CommandType.updateCommunicationPreference": "Update communication preference",
  "legalEntity.enum.CommandType.updateCompany": "Update company",
  "legalEntity.enum.CommandType.updateCompanyName": "Update company name",
  "legalEntity.enum.CommandType.updatePartnership": "Update partnership",
  "legalEntity.enum.CommandType.updatePerson": "Update person",
  "legalEntity.enum.CommunicationPreferenceType.digital": "Digital",
  "legalEntity.enum.CommunicationPreferenceType.post": "Post",
  "legalEntity.enum.Component.caseHandler": "",
  "legalEntity.enum.Component.legalEntity": "",
  "legalEntity.enum.Component.life": "",
  "legalEntity.enum.Component.moneyIn": "",
  "legalEntity.enum.Component.moneyOut": "",
  "legalEntity.enum.Component.unitlink": "",
  "legalEntity.enum.ConfigurationEntityType.EnumDefinition": "",
  "legalEntity.enum.ConfigurationEntityType.EnumLiteral": "",
  "legalEntity.enum.ConfigurationEntityType.GlMap": "",
  "legalEntity.enum.ConfigurationEntityType.ParameterDefinition": "",
  "legalEntity.enum.ConfigurationEntityType.ParameterValue": "",
  "legalEntity.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "legalEntity.enum.ConfigurationEntityType.RegisteredTenant": "",
  "legalEntity.enum.ConfigurationEntityType.Template": "",
  "legalEntity.enum.DataSubscriptionRoleType.unspecified": "",
  "legalEntity.enum.ExternalPayloadProcessStatusType.deleted": "Deleted",
  "legalEntity.enum.ExternalPayloadProcessStatusType.processed": "Processed",
  "legalEntity.enum.ExternalPayloadProcessStatusType.registered": "Registered",
  "legalEntity.enum.ExternalPayloadProcessStatusType.rejected": "Rejected",
  "legalEntity.enum.ExternalPayloadProcessStatusType.sent": "Sent",
  "legalEntity.enum.ExternalPayloadProcessStatusType.unsent": "Unsent",
  "legalEntity.enum.ExternalPayloadReceiver.collcalc": "",
  "legalEntity.enum.ExternalPayloadReceiver.datamart2": "",
  "legalEntity.enum.ExternalPayloadReceiver.external": "",
  "legalEntity.enum.ExternalPayloadReceiver.legalentity": "",
  "legalEntity.enum.ExternalPayloadReceiver.life": "",
  "legalEntity.enum.ExternalPayloadReceiver.moneyin": "",
  "legalEntity.enum.ExternalPayloadReceiver.moneyout": "",
  "legalEntity.enum.ExternalPayloadReceiver.unitlink": "",
  "legalEntity.enum.ExternalPayloadType.bs601BillingExt": "BS 601 billing ext",
  "legalEntity.enum.ExternalPayloadType.bulkDataExport": "Bulk data export",
  "legalEntity.enum.ExternalPayloadType.camt53": "camt.053",
  "legalEntity.enum.ExternalPayloadType.camt53Ext": "camt.053 ext",
  "legalEntity.enum.ExternalPayloadType.camt53Returns": "camt.053 returns",
  "legalEntity.enum.ExternalPayloadType.camt53ReturnsExt": "camt.053 returns ext",
  "legalEntity.enum.ExternalPayloadType.camt54": "camt.054",
  "legalEntity.enum.ExternalPayloadType.camt54Ext": "camt.054 ext",
  "legalEntity.enum.ExternalPayloadType.eIndkomstExt": "E indkomst ext",
  "legalEntity.enum.ExternalPayloadType.eIndkomstReceiptExt": "E indkomst receipt ext",
  "legalEntity.enum.ExternalPayloadType.generalLedger": "General ledger",
  "legalEntity.enum.ExternalPayloadType.legalEntityRecordsFile": "Legal entity records file",
  "legalEntity.enum.ExternalPayloadType.migration": "Migration",
  "legalEntity.enum.ExternalPayloadType.namingResponse": "",
  "legalEntity.enum.ExternalPayloadType.namingSystemDataRequestExt": "Naming system data request ext",
  "legalEntity.enum.ExternalPayloadType.namingSystemDataResponseExt": "Naming system data response ext",
  "legalEntity.enum.ExternalPayloadType.namingSystemMappingRequestExt": "Naming system mapping request ext",
  "legalEntity.enum.ExternalPayloadType.namingSystemMappingResponseExt": "Naming system mapping response ext",
  "legalEntity.enum.ExternalPayloadType.none": "None",
  "legalEntity.enum.ExternalPayloadType.pain001": "pain.001",
  "legalEntity.enum.ExternalPayloadType.pain001Ext": "pain.001 ext",
  "legalEntity.enum.ExternalPayloadType.pain002": "pain.002",
  "legalEntity.enum.ExternalPayloadType.pain002Ext": "pain.002 ext",
  "legalEntity.enum.ExternalPayloadType.personRegistrySubscriptionOutExt": "Person registry subscription out ext",
  "legalEntity.enum.ExternalPayloadType.testTransactionalIn": "Test transactional in",
  "legalEntity.enum.ExternalPayloadType.testTransactionalOut": "Test transactional out",
  "legalEntity.enum.ExternalPayloadType.testin": "Testin",
  "legalEntity.enum.ExternalPayloadType.testout": "Testout",
  "legalEntity.enum.FPlusCompletionItemTag.deprecated": "",
  "legalEntity.enum.Gender.Female": "Female",
  "legalEntity.enum.Gender.Male": "Male",
  "legalEntity.enum.Gender.Unknown": "Unknown",
  "legalEntity.enum.GenderMigrationV1Data.female": "",
  "legalEntity.enum.GenderMigrationV1Data.male": "",
  "legalEntity.enum.GenderMigrationV1Data.unknown": "",
  "legalEntity.enum.GlAggregationType.correction": "",
  "legalEntity.enum.GlAggregationType.counter": "",
  "legalEntity.enum.GlAggregationType.manual": "",
  "legalEntity.enum.GlAggregationType.normal": "",
  "legalEntity.enum.IdentityType.external": "External",
  "legalEntity.enum.IdentityType.internal": "Internal",
  "legalEntity.enum.InformationSource.employer": "Employer",
  "legalEntity.enum.InformationSource.migration": "Migration",
  "legalEntity.enum.InformationSource.participant": "Participant",
  "legalEntity.enum.LegalEntityRegistrySubscriptionStatus.subscribeInProgress": "Subscribe in progress",
  "legalEntity.enum.LegalEntityRegistrySubscriptionStatus.subscribed": "Subscribed",
  "legalEntity.enum.LegalEntityRegistrySubscriptionStatus.unsubscribeInProgress": "Ubsubscribe in progress",
  "legalEntity.enum.LegalEntityRegistrySubscriptionStatus.unsubscribed": "Unsubscribed",
  "legalEntity.enum.LegalEntityType.company": "",
  "legalEntity.enum.LegalEntityType.person": "",
  "legalEntity.enum.LogLevel.all": "",
  "legalEntity.enum.LogLevel.debug": "",
  "legalEntity.enum.LogLevel.error": "",
  "legalEntity.enum.LogLevel.info": "",
  "legalEntity.enum.LogLevel.off": "",
  "legalEntity.enum.LogLevel.trace": "",
  "legalEntity.enum.LogLevel.warn": "",
  "legalEntity.enum.MetaAssociationOutput.aggregation": "",
  "legalEntity.enum.MetaAssociationOutput.composition": "",
  "legalEntity.enum.MetaCardinalityOutput.many": "",
  "legalEntity.enum.MetaCardinalityOutput.one": "",
  "legalEntity.enum.PartnershipType.cohabitant": "Cohabitant",
  "legalEntity.enum.PartnershipType.married": "Married",
  "legalEntity.enum.PartnershipType.registeredPartnership": "Registered partnership",
  "legalEntity.enum.PartnershipTypeMigrationV1Data.cohabitant": "Cohabitant",
  "legalEntity.enum.PartnershipTypeMigrationV1Data.married": "Married",
  "legalEntity.enum.PartnershipTypeMigrationV1Data.registeredPartnership": "Registered partnership",
  "legalEntity.enum.PiiTextType.unspecified": "",
  "legalEntity.enum.PostingTable.BP": "",
  "legalEntity.enum.PostingTable.OPP": "",
  "legalEntity.enum.PostingType.glRounding": "General ledger rounding",
  "legalEntity.enum.PostingType.glRoundingExcluded": "General ledger rounding excluded",
  "legalEntity.enum.PostingType.none": "None",
  "legalEntity.enum.RegistrySubscriptionLevel.fullRegistrySubscription": "Full registry subscription",
  "legalEntity.enum.RegistrySubscriptionLevel.none": "None",
  "legalEntity.enum.RegistrySubscriptionLevel.onDemand": "On demand",
  "legalEntity.enum.RegistrySubscriptionRoleType.unspecified": "",
  "legalEntity.enum.ReportType.none": "None",
  "legalEntity.enum.ReportType.personRegistrySubscription": "",
  "legalEntity.enum.ReportingEventType.cancelled": "",
  "legalEntity.enum.ReportingEventType.newReport": "",
  "legalEntity.enum.ReportingEventType.reported": "",
  "legalEntity.enum.ReportingEventType.update": "",
  "legalEntity.enum.TestBatchSpecificationType.faulty": "",
  "legalEntity.enum.TestBatchSpecificationType.noop": "",
  "legalEntity.enum.TestBatchSpecificationType.normal": "",
  "legalEntity.enum.TransitExternalPayloadStatus.failed": "",
  "legalEntity.enum.TransitExternalPayloadStatus.modified": "",
  "legalEntity.enum.TransitExternalPayloadStatus.received": "",
  "life.enum.AccountType.billing": "Billing",
  "life.enum.AccountType.billingRequest": "Billing request",
  "life.enum.AccountType.billingRequestCounter": "Billing request counter",
  "life.enum.AccountType.claim": "Claim",
  "life.enum.AccountType.fromMoneyOutShadow": "From money out shadow",
  "life.enum.AccountType.layerReserve": "Layer reserve",
  "life.enum.AccountType.moneyIn": "Money in",
  "life.enum.AccountType.moneyInShadow": "Money in shadow",
  "life.enum.AccountType.moneyOut": "Money out",
  "life.enum.AccountType.moneyOutShadow": "Money out shadow",
  "life.enum.AccountType.none": "None",
  "life.enum.AccountType.payloadIn": "Payload in",
  "life.enum.AccountType.payloadRejected": "Payload rejected",
  "life.enum.AccountType.payloadShadow": "Payload shadow",
  "life.enum.AccountType.policyMoneyIn": "Policy money in",
  "life.enum.AccountType.rounding": "",
  "life.enum.AccountType.savings": "Savings",
  "life.enum.AccountType.sentToUnitlink": "Sent to unitlink",
  "life.enum.AccountType.toMoneyIn": "To money in",
  "life.enum.AccountType.toMoneyInShadow": "To money in shadow",
  "life.enum.AccountType.toMoneyOut": "To money out",
  "life.enum.AccountType.toUnitLinkOut": "To unitlink out",
  "life.enum.AccountType.toUnitLinkOutShadow": "To unitlink out shadow",
  "life.enum.AccountType.unitLinkIn": "Unitlink in",
  "life.enum.AccountType.unitLinkInShadow": "Unitlink in shadow",
  "life.enum.AccountType.unitLinkOut": "Unitlink out",
  "life.enum.AccountType.unitLinkOutCounter": "Unit link out counter",
  "life.enum.BatchStatusType.completed": "Completed",
  "life.enum.BatchStatusType.created": "Created",
  "life.enum.BatchStatusType.failed": "Failed",
  "life.enum.BatchStatusType.started": "Started",
  "life.enum.BatchStatusType.stopped": "Stopped",
  "life.enum.BillingChannel.bS": "",
  "life.enum.BillingFrequency.halfyear": "Half-yearly",
  "life.enum.BillingFrequency.month": "Monthly",
  "life.enum.BillingFrequency.quarter": "Quarterly",
  "life.enum.BillingFrequency.year": "Yearly",
  "life.enum.BulkDataType.Accounts": "",
  "life.enum.BulkDataType.BalancePostings": "",
  "life.enum.BulkDataType.Enums": "",
  "life.enum.BulkDataType.OpenPostPostings": "",
  "life.enum.BulkDataType.ParameterValueIntervals": "",
  "life.enum.BulkDataType.ParameterValues": "",
  "life.enum.BulkDataType.TariffTemplates": "",
  "life.enum.BulkDataType.Tenants": "",
  "life.enum.BulkDataType.WorkPads": "",
  "life.enum.BusinessType.company": "",
  "life.enum.BusinessType.person": "",
  "life.enum.CommandGroupType.advance": "Advance",
  "life.enum.CommandGroupType.annotation": "Annotation",
  "life.enum.CommandGroupType.calculation": "Calculation",
  "life.enum.CommandGroupType.employerAgreement": "Employer agreement",
  "life.enum.CommandGroupType.employment": "Employment",
  "life.enum.CommandGroupType.legalEntity": "Legal entity",
  "life.enum.CommandGroupType.moneyIn": "Money in",
  "life.enum.CommandGroupType.moneyOut": "Money out",
  "life.enum.CommandGroupType.none": "None",
  "life.enum.CommandGroupType.policyChange": "Policy change",
  "life.enum.CommandGroupType.posting": "Posting",
  "life.enum.CommandGroupType.tax": "Tax",
  "life.enum.CommandGroupType.unitlink": "Unitlink",
  "life.enum.CommandType.addAccessGroupAnnotation": "Add access group annotation",
  "life.enum.CommandType.addBalancePostings": "Add balance postings",
  "life.enum.CommandType.addManualPayment": "Handle manual payment",
  "life.enum.CommandType.amendAccessGroupAnnotation": "Amend access group annotation",
  "life.enum.CommandType.amendCoversSelection": "Handle amend covers selection",
  "life.enum.CommandType.amendEmployerAgreement": "Amend employer agreement",
  "life.enum.CommandType.amendEmployerAgreementCovers": "Amend employer agreement covers",
  "life.enum.CommandType.amendEmployerAgreementPolicies": "Amend employer agreement policies",
  "life.enum.CommandType.changeAgreement": "Change agreement",
  "life.enum.CommandType.changeCommitmentAndState": "Change commitment and state",
  "life.enum.CommandType.changeCommitmentTemplateSource": "Change commitment template source",
  "life.enum.CommandType.changeContributionData": "Change contribution data",
  "life.enum.CommandType.changeName": "Change name",
  "life.enum.CommandType.changeTaxExemption": "Tax exemption",
  "life.enum.CommandType.changeTemplateSource": "Change template source",
  "life.enum.CommandType.createAgreement": "Create agreement",
  "life.enum.CommandType.deathClaim": "Death claim",
  "life.enum.CommandType.deathClaimOrphan": "Death claim orphan",
  "life.enum.CommandType.defaultTemplate": "Default template",
  "life.enum.CommandType.employerAgreementRollback": "Employer agreement rollback",
  "life.enum.CommandType.employment": "Employment",
  "life.enum.CommandType.employmentContribution": "Employment contribution",
  "life.enum.CommandType.employmentEnd": "End employment",
  "life.enum.CommandType.employmentPosting": "Employment posting",
  "life.enum.CommandType.employmentStart": "Employment start",
  "life.enum.CommandType.employmentUpdate": "Employment update",
  "life.enum.CommandType.handleMoneyIn": "Handle money in",
  "life.enum.CommandType.handleMoneyInBillingPayment": "Handle billing payment",
  "life.enum.CommandType.handleUnitlinkBalance": "Handle unit link balance",
  "life.enum.CommandType.handleUnitlinkClosedPortfolio": "Handle unit link closed portfolio",
  "life.enum.CommandType.handleUnitlinkYield": "Handle unitlink yield",
  "life.enum.CommandType.insuredPersonState": "Insured person state",
  "life.enum.CommandType.internalCoverTransfer": "Internal cover transfer",
  "life.enum.CommandType.internalTransfer": "Internal transfer",
  "life.enum.CommandType.newCommitment": "New commitment",
  "life.enum.CommandType.newPolicy": "New policy",
  "life.enum.CommandType.pretendAddInsured": "Pretend add insured",
  "life.enum.CommandType.pretendDeath": "Pretend death",
  "life.enum.CommandType.prognosisHandleMoneyIn": "Prognosis handle money in",
  "life.enum.CommandType.prognosisHandleMoneyInBillingPayment": "Prognosis handle money in billing payment",
  "life.enum.CommandType.projectionJump": "Projection jump",
  "life.enum.CommandType.projectionStart": "Projection start",
  "life.enum.CommandType.relatedPersonState": "Related person state",
  "life.enum.CommandType.relatedPersonStateSimulation": "Related person state simulation",
  "life.enum.CommandType.removeAccessGroupAnnotation": "Remove access group annotation",
  "life.enum.CommandType.retirement": "Retirement",
  "life.enum.CommandType.rollback": "Rollback",
  "life.enum.CommandType.simulateTo": "Simulate to",
  "life.enum.CommandType.transformCover": "Transform cover",
  "life.enum.CommandType.valueTransferOut": "Value transfer out",
  "life.enum.CommitmentStatus.contribution": "Contribution",
  "life.enum.CommitmentStatus.death": "Death",
  "life.enum.CommitmentStatus.deathRegistered": "Death Registered",
  "life.enum.CommitmentStatus.disabled": "Disabled",
  "life.enum.CommitmentStatus.disbursement": "Disbursement",
  "life.enum.CommitmentStatus.paidUp": "Paid up",
  "life.enum.CommitmentStatus.partialDisabled": "Partial Disabled",
  "life.enum.CommitmentStatus.partialRetired": "Partial Retired",
  "life.enum.CommitmentStatus.premiumHoliday": "Premium Holiday",
  "life.enum.CommitmentStatus.retired": "Retired",
  "life.enum.CommitmentStatus.terminated": "Terminated",
  "life.enum.CommitmentStatus.unknown": "Unknown",
  "life.enum.CommitmentStatus.voluntaryContribution": "Voluntary contribution",
  "life.enum.ConfigurationEntityType.EnumDefinition": "",
  "life.enum.ConfigurationEntityType.EnumLiteral": "",
  "life.enum.ConfigurationEntityType.GlMap": "",
  "life.enum.ConfigurationEntityType.ParameterDefinition": "",
  "life.enum.ConfigurationEntityType.ParameterValue": "",
  "life.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "life.enum.ConfigurationEntityType.RegisteredTenant": "",
  "life.enum.ConfigurationEntityType.Template": "",
  "life.enum.CoverProductType.none": "None",
  "life.enum.CoverStatus.contribution": "Contribution",
  "life.enum.CoverStatus.disbursement": "Disbursement",
  "life.enum.CoverStatus.paidUp": "Paid up",
  "life.enum.CoverStatus.terminated": "Terminated",
  "life.enum.DataSubscriptionRoleType.unspecified": "",
  "life.enum.EditType.create": "",
  "life.enum.EditType.delete": "",
  "life.enum.EditType.update": "",
  "life.enum.EmployerAgreementEndType.none": "None",
  "life.enum.EmployerAgreementStatus.active": "Active",
  "life.enum.EmployerAgreementStatus.future": "Future",
  "life.enum.EmployerAgreementStatus.terminated": "Terminated",
  "life.enum.EmployerAgreementType.none": "None",
  "life.enum.ExternalPayloadProcessStatusType.deleted": "Deleted",
  "life.enum.ExternalPayloadProcessStatusType.processed": "Processed",
  "life.enum.ExternalPayloadProcessStatusType.registered": "Registered",
  "life.enum.ExternalPayloadProcessStatusType.rejected": "Rejected",
  "life.enum.ExternalPayloadProcessStatusType.sent": "Sent",
  "life.enum.ExternalPayloadProcessStatusType.unsent": "Unsent",
  "life.enum.ExternalPayloadReceiver.collcalc": "",
  "life.enum.ExternalPayloadReceiver.datamart2": "",
  "life.enum.ExternalPayloadReceiver.external": "",
  "life.enum.ExternalPayloadReceiver.legalentity": "",
  "life.enum.ExternalPayloadReceiver.life": "",
  "life.enum.ExternalPayloadReceiver.moneyin": "",
  "life.enum.ExternalPayloadReceiver.moneyout": "",
  "life.enum.ExternalPayloadReceiver.unitlink": "",
  "life.enum.ExternalPayloadType.bulkDataExport": "Bulk data export",
  "life.enum.ExternalPayloadType.camt53": "camt.053",
  "life.enum.ExternalPayloadType.camt53Returns": "camt.053 returns",
  "life.enum.ExternalPayloadType.camt54": "camt.054",
  "life.enum.ExternalPayloadType.generalLedger": "General ledger",
  "life.enum.ExternalPayloadType.migration": "Migration",
  "life.enum.ExternalPayloadType.namingResponse": "",
  "life.enum.ExternalPayloadType.none": "None",
  "life.enum.ExternalPayloadType.pain001": "pain.001",
  "life.enum.ExternalPayloadType.pain002": "pain.002",
  "life.enum.ExternalPayloadType.testTransactionalIn": "Test transactional in",
  "life.enum.ExternalPayloadType.testTransactionalOut": "Test transactional out",
  "life.enum.ExternalPayloadType.testin": "Testin",
  "life.enum.ExternalPayloadType.testout": "Testout",
  "life.enum.FPlusCompletionItemTag.deprecated": "",
  "life.enum.FrameCardinality.one": "",
  "life.enum.FrameCardinality.oneToMany": "",
  "life.enum.FrameCardinality.zeroToMany": "",
  "life.enum.FrameCardinality.zeroToOne": "",
  "life.enum.Gender.Female": "Female",
  "life.enum.Gender.Male": "Male",
  "life.enum.Gender.Unknown": "Unknown",
  "life.enum.GlAggregationType.correction": "",
  "life.enum.GlAggregationType.counter": "",
  "life.enum.GlAggregationType.manual": "",
  "life.enum.GlAggregationType.normal": "",
  "life.enum.LifeInsuranceEvent.accident": "Accident",
  "life.enum.LifeInsuranceEvent.criticalIllness": "Critical illness",
  "life.enum.LifeInsuranceEvent.death": "Death",
  "life.enum.LifeInsuranceEvent.deathOfRelated": "Death of related",
  "life.enum.LifeInsuranceEvent.disability": "Disability",
  "life.enum.LifeInsuranceEvent.divorce": "Divorce",
  "life.enum.LifeInsuranceEvent.lossOfLicense": "Loss of license",
  "life.enum.LifeInsuranceEvent.paidUp": "Paid up",
  "life.enum.LifeInsuranceEvent.premiumHoliday": "Premium holiday",
  "life.enum.LifeInsuranceEvent.retirement": "Retirement",
  "life.enum.LifeInsuranceEvent.surrender": "Surrender",
  "life.enum.LifeInsuranceEvent.transferOut": "Transfer out",
  "life.enum.LifeInsuranceEvent.transferOutDivorce": "Transfer out (divorce)",
  "life.enum.LifeInsuranceEvent.voluntaryContinuation": "Voluntary continuation",
  "life.enum.LogLevel.all": "",
  "life.enum.LogLevel.debug": "",
  "life.enum.LogLevel.error": "",
  "life.enum.LogLevel.info": "",
  "life.enum.LogLevel.off": "",
  "life.enum.LogLevel.trace": "",
  "life.enum.LogLevel.warn": "",
  "life.enum.MetaAssociationOutput.aggregation": "",
  "life.enum.MetaAssociationOutput.composition": "",
  "life.enum.MetaCardinalityOutput.many": "",
  "life.enum.MetaCardinalityOutput.one": "",
  "life.enum.MoneyInTaxcode.none": "-",
  "life.enum.MoneyOutPeriodDuration.halfYearly": "Half-yearly",
  "life.enum.MoneyOutPeriodDuration.monthly": "Monthly",
  "life.enum.MoneyOutPeriodDuration.quarterly": "Quarterly",
  "life.enum.MoneyOutPeriodDuration.single": "Single",
  "life.enum.MoneyOutPeriodDuration.yearly": "Yearly",
  "life.enum.MoneyOutTaxcode.none": "None",
  "life.enum.MoneyOutType.adhoc": "Adhoc",
  "life.enum.MoneyOutType.annuity": "Annuity",
  "life.enum.MoneyOutType.lumpsum": "Lump sum",
  "life.enum.MoneyOutType.wop": "Wop",
  "life.enum.MoneyPeriodType.benefit": "",
  "life.enum.MoneyPeriodType.saving": "",
  "life.enum.NotificationType.alert": "",
  "life.enum.NotificationType.info": "",
  "life.enum.NotificationType.warning": "",
  "life.enum.PartnershipType.cohabitant": "Cohabitant",
  "life.enum.PartnershipType.married": "Married",
  "life.enum.PartnershipType.registeredPartnership": "Registered partnership",
  "life.enum.PolicyCreateType.deathTransformation": "Death transformation",
  "life.enum.PolicyCreateType.disabilityTransformation": "Disability transformation",
  "life.enum.PolicyCreateType.incomingPayment": "Incoming payment",
  "life.enum.PolicyCreateType.incomingTransfer": "Incoming transfer",
  "life.enum.PolicyCreateType.manual": "Manual",
  "life.enum.PolicyCreateType.retirementTransformation": "Retirement transformation",
  "life.enum.PolicyProductType.none": "None",
  "life.enum.PolicyStatus.contribution": "Contribution",
  "life.enum.PolicyStatus.death": "Death",
  "life.enum.PolicyStatus.disabled": "Disabled",
  "life.enum.PolicyStatus.disbursement": "Disbursement",
  "life.enum.PolicyStatus.none": "None",
  "life.enum.PolicyStatus.paidUp": "Paid up",
  "life.enum.PolicyStatus.premiumHoliday": "Premium holiday",
  "life.enum.PolicyStatus.retired": "Retired",
  "life.enum.PolicyStatus.surrended": "Surrended",
  "life.enum.PolicyStatus.terminated": "Terminated",
  "life.enum.PolicyTerminateType.death": "",
  "life.enum.PolicyTerminateType.merge": "",
  "life.enum.PolicyTerminateType.outgoingTransfer": "",
  "life.enum.PolicyTerminateType.policyEnd": "",
  "life.enum.PolicyTerminateType.retirement": "",
  "life.enum.PolicyTerminateType.surrender": "",
  "life.enum.PostingTable.BP": "BP",
  "life.enum.PostingTable.OPP": "OPP",
  "life.enum.PostingType.balanceFromUnitlink": "Balance from unitlink",
  "life.enum.PostingType.balanceToUnitLink": "Balance to unitlink",
  "life.enum.PostingType.billing": "Billing",
  "life.enum.PostingType.billingRequest": "Billing request",
  "life.enum.PostingType.closeSubPortfolio": "Close sub-portfolio",
  "life.enum.PostingType.costFromUnitLink": "Cost from unitlink",
  "life.enum.PostingType.coverTransferredToUnitLinkCounterpost": "Cover transferred to unit link counterpost",
  "life.enum.PostingType.coverTransferredToUnitLinkWithNoTradeCosts": "Cover transferred to unit link with no trade costs",
  "life.enum.PostingType.coverTransferrredToUnitLink": "Cover transferred to unit link",
  "life.enum.PostingType.employmentIn": "Employment in",
  "life.enum.PostingType.endEmploymentToUnitlink": "End employment to unitlink",
  "life.enum.PostingType.fixSentToUnitlinkFromState": "Fix sent to unitlink from state",
  "life.enum.PostingType.fundCostFromUnitlink": "Fund cost from unitlink",
  "life.enum.PostingType.glRounding": "General ledger rounding",
  "life.enum.PostingType.glRoundingExcluded": "General ledger rounding excluded",
  "life.enum.PostingType.internalBalanceTransfer": "Internal balance transfer",
  "life.enum.PostingType.internalTransferBetweenCommitments": 'Internal transfer"',
  "life.enum.PostingType.internalTransferBetweenDims": "Internal transfer",
  "life.enum.PostingType.migrationBalance": "Migration balance",
  "life.enum.PostingType.moneyIn": "Money in",
  "life.enum.PostingType.moneyOut": "Money out",
  "life.enum.PostingType.moneyOutNoProofOfLife": "Money-out no proof of life",
  "life.enum.PostingType.moneyOutNoSignOfLife": "Money-out no sign of life",
  "life.enum.PostingType.moveBalanceFromUnitLink": "Move Balance from unitlink",
  "life.enum.PostingType.moveBalanceNotInvestedToUnitLink": "",
  "life.enum.PostingType.moveBalanceToUnitLink": "Move balance to unitLink",
  "life.enum.PostingType.newCoverToUnitLink": "New cover to unitlink",
  "life.enum.PostingType.none": "None",
  "life.enum.PostingType.payloadRejected": "Payload rejected",
  "life.enum.PostingType.receivedInternalTransferBetweenCommitments": "Received internal transfer between commitments",
  "life.enum.PostingType.requestBalanceUpdate": "Request balance update",
  "life.enum.PostingType.reserveJumpDeath": "Reserve jump death",
  "life.enum.PostingType.reserveJumpDisability": "Reserve jump disability",
  "life.enum.PostingType.revertSendEndEmploymentToUnitLink": "Revert send end employment to unit link",
  "life.enum.PostingType.revertSendMoveBalanceToUnitLink": "Revert send moved balance to unitLink",
  "life.enum.PostingType.revertSendNewCoverToUnitLink": "Revert send new cover to unitLink",
  "life.enum.PostingType.revertSendStartEmploymentToUnitLink": "Revert send start employment to unit link",
  "life.enum.PostingType.revertSendUnitLinkSubPortfolioClose": "Revert send unitlink sub portfolio close",
  "life.enum.PostingType.riskPremiumDeath": "Risk premium death",
  "life.enum.PostingType.riskPrmSurvival": "Risk prm survival",
  "life.enum.PostingType.rounding": "Rounding",
  "life.enum.PostingType.sendBalanceToUnitLink": "Send balance to unitLink",
  "life.enum.PostingType.sendEndEmploymentToUnitLink": "Send end employment to unit link",
  "life.enum.PostingType.sendMoveBalanceNotInvestedToUnitLink": "",
  "life.enum.PostingType.sendMoveBalanceToUnitLink": "Send move balance to unitlink",
  "life.enum.PostingType.sendNewCoverToUnitLink": "Send new cover to unitlink",
  "life.enum.PostingType.sendStartEmploymentToUnitLink": "Send start employment to unit link",
  "life.enum.PostingType.sendUnitLinkSubPortfolioClose": "Send unitlink sub portfolio close",
  "life.enum.PostingType.sentInternalTransferBetweenCommitments": "Sent internal transfer between commitments",
  "life.enum.PostingType.sentMoneyOut": "Sent money out",
  "life.enum.PostingType.sentValueTransferOut": "Sent value transfer out",
  "life.enum.PostingType.startEmploymentToUnitLink": "Start employment to unit link",
  "life.enum.PostingType.tradeCostFromUnitlink": "Trade cost from unitlink",
  "life.enum.PostingType.transferSentToUnitlinkBetweenCovers": "Transfer sent to unitlink between covers",
  "life.enum.PostingType.unitLinkSubPortfolioClose": "Unitlink sub-portfolio close",
  "life.enum.PostingType.usedValueTransferIn": "Used incoming value transfer",
  "life.enum.PostingType.valuationPrmBilling": "Valuation prm billing",
  "life.enum.PostingType.valuationResidual": "Valuation residual",
  "life.enum.PostingType.valueTransferIn": "Incoming value transfer",
  "life.enum.PostingType.valueTransferOut": "Outgoing value transfer",
  "life.enum.PostingType.writeOff": "Write off",
  "life.enum.PostingType.yield": "Yield",
  "life.enum.PostingType.yieldAfterMoveFromUnitLink": "",
  "life.enum.PostingType.yieldFromUnitLink": "Yield from unitlink",
  "life.enum.PremiumHolidayType.none": "None",
  "life.enum.ProfileType.individualProfile": "Individual profile",
  "life.enum.ProfileType.lifeCycleProfile": "Life cycle profile",
  "life.enum.ProjectionType.nearTimeSimulation": "",
  "life.enum.ProjectionType.none": "None",
  "life.enum.RelationshipType.child": "Child",
  "life.enum.RelationshipType.cohabitant": "Cohabitant",
  "life.enum.RelationshipType.none": "None",
  "life.enum.RelationshipType.registeredPartner": "Registered partner",
  "life.enum.RelationshipType.spouse": "Spouse",
  "life.enum.ReportType.none": "None",
  "life.enum.ReportingEventType.cancelled": "",
  "life.enum.ReportingEventType.newReport": "",
  "life.enum.ReportingEventType.reported": "",
  "life.enum.ReportingEventType.update": "",
  "life.enum.SavingsTaxcode.none": "None",
  "life.enum.TenantSubGroup.none": "None",
  "life.enum.TestBatchSpecificationType.faulty": "",
  "life.enum.TestBatchSpecificationType.noop": "",
  "life.enum.TestBatchSpecificationType.normal": "",
  "life.enum.UnitlinkStatus.inUnitlink": "In unitlink",
  "life.enum.UnitlinkStatus.leavingUnitlink": "Leaving unitlink",
  "life.enum.UnitlinkStatus.notInUnitlink": "Not in unitlink",
  "life.enum.UnitlinkStatus.notInvestedInUnitlink": "Not invested in unitlink",
  "life.enum.VoluntaryContributionPlacement.none": "None",
  "moneyIn.enum.AccountType.bankShadow": "Bank shadow",
  "moneyIn.enum.AccountType.billedFees": "Billed fees",
  "moneyIn.enum.AccountType.completedInvoices": "Completed invoices",
  "moneyIn.enum.AccountType.convertedHistoricContributions": "Converted historic contributions",
  "moneyIn.enum.AccountType.convertedShadow": "Converted shadow",
  "moneyIn.enum.AccountType.distributedPayments": "Distributed payments",
  "moneyIn.enum.AccountType.employerAssumedPayments": "Employer assumed payments",
  "moneyIn.enum.AccountType.employerBilling": "Employer billing",
  "moneyIn.enum.AccountType.employerBillingRequest": "Employer billing request",
  "moneyIn.enum.AccountType.employerContributions": "Employer contributions",
  "moneyIn.enum.AccountType.employerReceivables": "Employer receivables",
  "moneyIn.enum.AccountType.externalShadow": "External shadow",
  "moneyIn.enum.AccountType.infoServiceReconcile": "Info service reconcile",
  "moneyIn.enum.AccountType.infoServiceReturns": "Info service returns",
  "moneyIn.enum.AccountType.invoiceElements": "Invoice elements",
  "moneyIn.enum.AccountType.invoicePayments": "Invoice payments",
  "moneyIn.enum.AccountType.invoicesLifeShadow": "Invoices life shadow",
  "moneyIn.enum.AccountType.lifeShadow": "Life shadow",
  "moneyIn.enum.AccountType.moneyOutShadow": "Money out shadow",
  "moneyIn.enum.AccountType.none": "None",
  "moneyIn.enum.AccountType.paidFees": "Paid fees",
  "moneyIn.enum.AccountType.payments": "Payments",
  "moneyIn.enum.AccountType.pendingBilling": "Pending billing",
  "moneyIn.enum.AccountType.pendingTransitContributions": "Pending transit contributions",
  "moneyIn.enum.AccountType.personBillingRequest": "Person billing request",
  "moneyIn.enum.AccountType.personContributions": "Person contributions",
  "moneyIn.enum.AccountType.personPrivateBillings": "Person private billings",
  "moneyIn.enum.AccountType.personReceivables": "Person receivables",
  "moneyIn.enum.AccountType.receivables": "Receivables",
  "moneyIn.enum.AccountType.rounding": "",
  "moneyIn.enum.AccountType.sentBillings": "Sent billings",
  "moneyIn.enum.AccountType.toLife": "To life",
  "moneyIn.enum.AccountType.toMoneyOut": "To money out",
  "moneyIn.enum.AccountType.transitContributions": "Transit contributions",
  "moneyIn.enum.AccountType.unclaimedPayments": "Unclaimed payments",
  "moneyIn.enum.AccountType.undistributedPayments": "Undistributed payments",
  "moneyIn.enum.AccountType.undistributedReceivables": "Undistributed receivables",
  "moneyIn.enum.AccountType.unrelatedPaymentsShadow": "Unrelated payments shadow",
  "moneyIn.enum.AccountType.upcomingBillings": "Upcoming billings",
  "moneyIn.enum.AccountType.writeOffShadow": "Write off shadow",
  "moneyIn.enum.BankAccountKind.Iban": "",
  "moneyIn.enum.BankAccountKind.Other": "",
  "moneyIn.enum.BatchStatusType.completed": "Completed",
  "moneyIn.enum.BatchStatusType.created": "Created",
  "moneyIn.enum.BatchStatusType.failed": "Failed",
  "moneyIn.enum.BatchStatusType.started": "Started",
  "moneyIn.enum.BatchStatusType.stopped": "Stopped",
  "moneyIn.enum.BillingChannel.bS": "BS",
  "moneyIn.enum.BillingFrequency.halfyear": "Half year",
  "moneyIn.enum.BillingFrequency.month": "Month",
  "moneyIn.enum.BillingFrequency.quarter": "Quarter",
  "moneyIn.enum.BillingFrequency.year": "Year",
  "moneyIn.enum.BillingMethodType.none": "None",
  "moneyIn.enum.BulkDataType.Accounts": "",
  "moneyIn.enum.BulkDataType.BalancePostings": "",
  "moneyIn.enum.BulkDataType.Enums": "",
  "moneyIn.enum.BulkDataType.OpenPostPostings": "",
  "moneyIn.enum.BulkDataType.ParameterValueIntervals": "",
  "moneyIn.enum.BulkDataType.ParameterValues": "",
  "moneyIn.enum.BulkDataType.TariffTemplates": "",
  "moneyIn.enum.BulkDataType.Tenants": "",
  "moneyIn.enum.BulkDataType.WorkPads": "",
  "moneyIn.enum.BusinessType.company": "",
  "moneyIn.enum.BusinessType.person": "",
  "moneyIn.enum.CommandGroupType.advance": "Advance",
  "moneyIn.enum.CommandGroupType.annotation": "Annotation",
  "moneyIn.enum.CommandGroupType.calculation": "Calculation",
  "moneyIn.enum.CommandGroupType.employerAgreement": "Employer agreement",
  "moneyIn.enum.CommandGroupType.employment": "Employment",
  "moneyIn.enum.CommandGroupType.invoice": "Invoice",
  "moneyIn.enum.CommandGroupType.legalEntity": "Legal entity",
  "moneyIn.enum.CommandGroupType.moneyIn": "Money in",
  "moneyIn.enum.CommandGroupType.moneyOut": "Money out",
  "moneyIn.enum.CommandGroupType.none": "None",
  "moneyIn.enum.CommandGroupType.policyChange": "Policy change",
  "moneyIn.enum.CommandGroupType.posting": "Posting",
  "moneyIn.enum.CommandGroupType.tax": "Tax",
  "moneyIn.enum.CommandGroupType.unitlink": "Unitlink",
  "moneyIn.enum.CommandType.addAccessGroupAnnotation": "Add access group annotation",
  "moneyIn.enum.CommandType.addInvoiceToInstallmentPlan": "Add invoice to installment plan",
  "moneyIn.enum.CommandType.addPaymentInvoice": "Add payment invoice",
  "moneyIn.enum.CommandType.amendAccessGroupAnnotation": "Amend access group annotation",
  "moneyIn.enum.CommandType.autoPauseInvoice": "Auto pause invoice",
  "moneyIn.enum.CommandType.cancelInvoice": "Cancel invoice",
  "moneyIn.enum.CommandType.createInvoice": "Create invoice",
  "moneyIn.enum.CommandType.creditPaymentInvoice": "Credit payment invoice",
  "moneyIn.enum.CommandType.defaultTemplate": "Default template",
  "moneyIn.enum.CommandType.disablePenaltiesInvoice": "Disable penalties invoice",
  "moneyIn.enum.CommandType.pauseInvoice": "Pause invoice",
  "moneyIn.enum.CommandType.reconcileInvoice": "Reconcile invoice",
  "moneyIn.enum.CommandType.removeAccessGroupAnnotation": "Remove access group annotation",
  "moneyIn.enum.CommandType.removeInvoiceFromInstallmentPlan": "Remove invoice from installment plan",
  "moneyIn.enum.CommandType.resumeInvoice": "Resume invoice",
  "moneyIn.enum.CommandType.resumeInvoiceWithNextOperation": "Resume invoice with next operation",
  "moneyIn.enum.CommandType.triggeredPauseInvoice": "Triggered pause invoice",
  "moneyIn.enum.CommandType.withdrawPaymentInvoice": "Withdraw payment invoice",
  "moneyIn.enum.CommandType.writeOffInvoice": "Write off invoice",
  "moneyIn.enum.CompanyStatus.none": "None",
  "moneyIn.enum.ConfigurationEntityType.EnumDefinition": "",
  "moneyIn.enum.ConfigurationEntityType.EnumLiteral": "",
  "moneyIn.enum.ConfigurationEntityType.GlMap": "",
  "moneyIn.enum.ConfigurationEntityType.ParameterDefinition": "",
  "moneyIn.enum.ConfigurationEntityType.ParameterValue": "",
  "moneyIn.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "moneyIn.enum.ConfigurationEntityType.RegisteredTenant": "",
  "moneyIn.enum.ConfigurationEntityType.Template": "",
  "moneyIn.enum.DataSubscriptionRoleType.unspecified": "",
  "moneyIn.enum.ExternalPayloadProcessStatusType.deleted": "Deleted",
  "moneyIn.enum.ExternalPayloadProcessStatusType.processed": "Processed",
  "moneyIn.enum.ExternalPayloadProcessStatusType.registered": "Registered",
  "moneyIn.enum.ExternalPayloadProcessStatusType.rejected": "Rejected",
  "moneyIn.enum.ExternalPayloadProcessStatusType.sent": "Sent",
  "moneyIn.enum.ExternalPayloadProcessStatusType.unsent": "Unsent",
  "moneyIn.enum.ExternalPayloadReceiver.collcalc": "",
  "moneyIn.enum.ExternalPayloadReceiver.datamart2": "",
  "moneyIn.enum.ExternalPayloadReceiver.external": "",
  "moneyIn.enum.ExternalPayloadReceiver.legalentity": "",
  "moneyIn.enum.ExternalPayloadReceiver.life": "",
  "moneyIn.enum.ExternalPayloadReceiver.moneyin": "",
  "moneyIn.enum.ExternalPayloadReceiver.moneyout": "",
  "moneyIn.enum.ExternalPayloadReceiver.unitlink": "",
  "moneyIn.enum.ExternalPayloadType.bulkDataExport": "Bulk data export",
  "moneyIn.enum.ExternalPayloadType.camt53": "camt.053",
  "moneyIn.enum.ExternalPayloadType.camt53Returns": "camt.053 returns",
  "moneyIn.enum.ExternalPayloadType.camt54": "camt.054",
  "moneyIn.enum.ExternalPayloadType.generalLedger": "General ledger",
  "moneyIn.enum.ExternalPayloadType.migration": "Migration",
  "moneyIn.enum.ExternalPayloadType.moneyInConversion": "Money in conversion",
  "moneyIn.enum.ExternalPayloadType.namingResponse": "",
  "moneyIn.enum.ExternalPayloadType.netAxept": "Netaxept",
  "moneyIn.enum.ExternalPayloadType.none": "None",
  "moneyIn.enum.ExternalPayloadType.pain001": "pain.001",
  "moneyIn.enum.ExternalPayloadType.pain002": "pain.002",
  "moneyIn.enum.ExternalPayloadType.testTransactionalIn": "Test transactional in",
  "moneyIn.enum.ExternalPayloadType.testTransactionalOut": "Test transactional out",
  "moneyIn.enum.ExternalPayloadType.testin": "Testin",
  "moneyIn.enum.ExternalPayloadType.testout": "Testout",
  "moneyIn.enum.ExternalPaymentDirectDebitType.crossBorder": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.intraCompany": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.none": "None",
  "moneyIn.enum.ExternalPaymentDirectDebitType.sepaB2b": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.sepaCore": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.unpaid": "",
  "moneyIn.enum.FPlusCompletionItemTag.deprecated": "",
  "moneyIn.enum.Gender.Female": "",
  "moneyIn.enum.Gender.Male": "",
  "moneyIn.enum.Gender.Unknown": "",
  "moneyIn.enum.GlAggregationType.correction": "",
  "moneyIn.enum.GlAggregationType.counter": "",
  "moneyIn.enum.GlAggregationType.manual": "",
  "moneyIn.enum.GlAggregationType.normal": "",
  "moneyIn.enum.InvoiceBundlingPenaltyType.none": "None",
  "moneyIn.enum.InvoicePayerType.Company": "",
  "moneyIn.enum.InvoicePayerType.Person": "",
  "moneyIn.enum.InvoiceStatus.billed": "Billed",
  "moneyIn.enum.InvoiceStatus.cancelled": "Cancelled",
  "moneyIn.enum.InvoiceStatus.created": "Created",
  "moneyIn.enum.InvoiceStatus.reconciled": "Reconciled",
  "moneyIn.enum.InvoiceStatus.reminded": "Reminded",
  "moneyIn.enum.InvoiceStatus.terminated": "Terminated",
  "moneyIn.enum.InvoiceTerminationAction.ignore": "",
  "moneyIn.enum.InvoiceTerminationAction.reverse": "",
  "moneyIn.enum.InvoiceTerminationAction.writeOff": "",
  "moneyIn.enum.InvoiceType.installmentPlanInvoice": "Installment plan",
  "moneyIn.enum.InvoiceWriteOffCategory.none": "None",
  "moneyIn.enum.InvoiceWriteOffType.automatic": "Automatic",
  "moneyIn.enum.InvoiceWriteOffType.manual": "Manual",
  "moneyIn.enum.LogLevel.all": "",
  "moneyIn.enum.LogLevel.debug": "",
  "moneyIn.enum.LogLevel.error": "",
  "moneyIn.enum.LogLevel.info": "",
  "moneyIn.enum.LogLevel.off": "",
  "moneyIn.enum.LogLevel.trace": "",
  "moneyIn.enum.LogLevel.warn": "",
  "moneyIn.enum.MetaAssociationOutput.aggregation": "",
  "moneyIn.enum.MetaAssociationOutput.composition": "",
  "moneyIn.enum.MetaCardinalityOutput.many": "",
  "moneyIn.enum.MetaCardinalityOutput.one": "",
  "moneyIn.enum.PayerMapUpdateCause.api": "",
  "moneyIn.enum.PayerMapUpdateCause.incomingPayment": "",
  "moneyIn.enum.PaymentOwnerType.company": "",
  "moneyIn.enum.PaymentOwnerType.none": "None",
  "moneyIn.enum.PaymentOwnerType.person": "",
  "moneyIn.enum.PaymentReceiverType.Account": "",
  "moneyIn.enum.PaymentReceiverType.LegalEntity": "",
  "moneyIn.enum.PaymentReceiverType.PaymentSender": "",
  "moneyIn.enum.PaymentStatus.closed": "Closed",
  "moneyIn.enum.PaymentStatus.open": "Open",
  "moneyIn.enum.PaymentType.directDebitBatch": "Direct Debit Batch",
  "moneyIn.enum.PaymentType.unrelatedPayment": "Unrelated payment",
  "moneyIn.enum.PostingTable.BP": "",
  "moneyIn.enum.PostingTable.OPP": "",
  "moneyIn.enum.PostingType.approvedEmployeeContribution": "Approved employee contribution",
  "moneyIn.enum.PostingType.approvedNetAxeptContribution": "Approved Netaxept contribution",
  "moneyIn.enum.PostingType.approvedPrivateBillingPaymentEntry": "Approved private billing payment entry",
  "moneyIn.enum.PostingType.approvedTransitEmployeeContribution": "Approved transit employee contribution",
  "moneyIn.enum.PostingType.billingPaymentEntry": "Billing payment entry",
  "moneyIn.enum.PostingType.cancelledBilling": "Cancelled billing",
  "moneyIn.enum.PostingType.cancelledPrivateBilling": "Cancelled private billing",
  "moneyIn.enum.PostingType.convertedHistoricContribution": "Converted historic contribution",
  "moneyIn.enum.PostingType.directDebitInvoicePayment": "Direct debit invoice payment",
  "moneyIn.enum.PostingType.directDebitInvoicePaymentCancellation": "Direct debit invoice payment cancellation",
  "moneyIn.enum.PostingType.directDebitPayment": "Direct debit payment",
  "moneyIn.enum.PostingType.directDebitPaymentSpec": "Direct debit payment spec",
  "moneyIn.enum.PostingType.directDebitPaymentSpecEntry": "Direct debit payment spec entry",
  "moneyIn.enum.PostingType.directDebitPaymentSpecEntryReconcile": "Direct debit payment spec entry reconcile",
  "moneyIn.enum.PostingType.directDebitPaymentSpecReconcile": "Direct debit payment spec reconcile",
  "moneyIn.enum.PostingType.employeeBilling": "Employee billing",
  "moneyIn.enum.PostingType.employeeBillingReconcile": "Employee billing reconcile",
  "moneyIn.enum.PostingType.employeeContribution": "Employee contribution",
  "moneyIn.enum.PostingType.employeeReceivablesSpec": "Employee receivables spec",
  "moneyIn.enum.PostingType.employeeReceivablesSpecReconcile": "Employee receivables spec reconcile",
  "moneyIn.enum.PostingType.employerBilling": "Employer billing",
  "moneyIn.enum.PostingType.employerContribution": "Employer contribution",
  "moneyIn.enum.PostingType.employerReceivablesSpec": "Employer receivables spec",
  "moneyIn.enum.PostingType.employerReceivablesSpecDistribution": "Employer receivables spec distribution",
  "moneyIn.enum.PostingType.employerReceivablesSpecReconcile": "Employer receivables spec reconcile",
  "moneyIn.enum.PostingType.externallyHandledEmployeeContribution": "Externally handled employee contribution",
  "moneyIn.enum.PostingType.externallyHandledEmployerContribution": "Externally handled employer contribution",
  "moneyIn.enum.PostingType.glRounding": "General ledger rounding",
  "moneyIn.enum.PostingType.glRoundingExcluded": "General ledger rounding excluded",
  "moneyIn.enum.PostingType.incomingValueTransfer": "Incoming value transfer",
  "moneyIn.enum.PostingType.incomingValueTransferReconcile": "Incoming value transfer reconcile",
  "moneyIn.enum.PostingType.infoServiceContribution": "Info service contribution",
  "moneyIn.enum.PostingType.infoServicePayment": "Info service payment",
  "moneyIn.enum.PostingType.infoServicePaymentSpec": "Info service payment spec",
  "moneyIn.enum.PostingType.infoServicePaymentSpecReconcile": "Info service payment spec reconcile",
  "moneyIn.enum.PostingType.installmentPlanBilling": "Installment plan billing",
  "moneyIn.enum.PostingType.installmentPlanBillingBundled": "Installment plan billing bundled",
  "moneyIn.enum.PostingType.invalidEmployeeReceivablesSpec": "Invalid employee receivables spec",
  "moneyIn.enum.PostingType.invalidManualEmployeeReceivablesSpec": "Invalid manual employee receivables spec",
  "moneyIn.enum.PostingType.invoiceBundlingPenalty": "Invoice bundling penalty",
  "moneyIn.enum.PostingType.invoicePaymentRedistribution": "Invoice payment redistribution",
  "moneyIn.enum.PostingType.invoiceTermination": "Invoice termination",
  "moneyIn.enum.PostingType.invoiceWriteOff": "Invoice write off",
  "moneyIn.enum.PostingType.manualContribution": "Manual contribution",
  "moneyIn.enum.PostingType.manualEmployeeReceivablesSpec": "Manual employee receivables spec",
  "moneyIn.enum.PostingType.manualEmployeeReceivablesSpecDelete": "Manual employee receivables spec delete",
  "moneyIn.enum.PostingType.manualEmployeeReceivablesSpecEdit": "Manual employee receivables spec edit",
  "moneyIn.enum.PostingType.manualEmployeeReceivablesSpecReconcile": "Manual employee receivables spec reconcile",
  "moneyIn.enum.PostingType.manualEmployerReceivablesSpec": "Manual employer receivables spec",
  "moneyIn.enum.PostingType.manualEmployerReceivablesSpecDistribution": "Manual employer receivables spec distribution",
  "moneyIn.enum.PostingType.manualEmployerReceivablesSpecEdit": "Manual employer receivables spec edit",
  "moneyIn.enum.PostingType.manualEmployerReceivablesSpecEditDistribution": "Manual employer receivables spec edit distribution",
  "moneyIn.enum.PostingType.manualPayment": "Manual payment",
  "moneyIn.enum.PostingType.manualPaymentSpec": "Manual payment spec",
  "moneyIn.enum.PostingType.manualPaymentSpecReconcile": "Manual payment spec reconcile",
  "moneyIn.enum.PostingType.manualReturnEmployeeContribution": "Manual return employee contribution",
  "moneyIn.enum.PostingType.netAxeptContribution": "Netaxept contribution",
  "moneyIn.enum.PostingType.netAxeptPayment": "Netaxept payment",
  "moneyIn.enum.PostingType.netAxeptPaymentSpec": "Netaxept payment spec",
  "moneyIn.enum.PostingType.netAxeptPaymentSpecEntry": "Netaxept payment spec entry",
  "moneyIn.enum.PostingType.netAxeptPaymentSpecEntryReconcile": "Netaxept payment spec entry reconcile",
  "moneyIn.enum.PostingType.netAxeptPaymentSpecReconcile": "Netaxept payment spec reconcile",
  "moneyIn.enum.PostingType.none": "None",
  "moneyIn.enum.PostingType.paidInvoiceBundlingPenalty": "Paid invoice bundling penalty",
  "moneyIn.enum.PostingType.paymentCredit": "Payment credit",
  "moneyIn.enum.PostingType.pensionTransfer": "Pension transfer",
  "moneyIn.enum.PostingType.personPrivateBilling": "Person private billing",
  "moneyIn.enum.PostingType.personPrivateBillingReconcile": "Person private billing reconcile",
  "moneyIn.enum.PostingType.privateBilling": "Private billing",
  "moneyIn.enum.PostingType.privateBillingPaymentEntry": "Private billing payment entry",
  "moneyIn.enum.PostingType.privateBillingReconcile": "Private billing reconcile",
  "moneyIn.enum.PostingType.privateReminder": "Private reminder",
  "moneyIn.enum.PostingType.reminderFee": "Reminder fee",
  "moneyIn.enum.PostingType.returnedContribution": "Returned contribution",
  "moneyIn.enum.PostingType.transitContributionOut": "Transit contribution out",
  "moneyIn.enum.PostingType.transitEmployeeContribution": "Transit employee contribution",
  "moneyIn.enum.PostingType.transitEmployeeReceivablesSpec": "Transit employee receivables spec",
  "moneyIn.enum.PostingType.transitEmployeeReceivablesSpecReconcile": "Transit employee receivables spec reconcile",
  "moneyIn.enum.PostingType.unexpectedCancelledPrivateBilling": "Unexpected cancelled private billing",
  "moneyIn.enum.PostingType.unknownPayment": "Unknown payment",
  "moneyIn.enum.PostingType.unrelatedPayment": "Unrelated payment",
  "moneyIn.enum.PostingType.voluntaryContribution": "Voluntary contribution",
  "moneyIn.enum.PostingType.withdrawnContribution": "Withdrawn contribution",
  "moneyIn.enum.ReportType.none": "None",
  "moneyIn.enum.ReportingEventType.cancelled": "",
  "moneyIn.enum.ReportingEventType.newReport": "",
  "moneyIn.enum.ReportingEventType.reported": "",
  "moneyIn.enum.ReportingEventType.update": "",
  "moneyIn.enum.TestBatchSpecificationType.faulty": "",
  "moneyIn.enum.TestBatchSpecificationType.noop": "",
  "moneyIn.enum.TestBatchSpecificationType.normal": "",
  "moneyIn.enum.UnexpectedInvoicePaymentType.excessAmount": "",
  "moneyIn.enum.UnexpectedInvoicePaymentType.insufficientAmount": "",
  "moneyIn.enum.UnrelatedPaymentType.none": "None",
  "moneyIn.enum.ValidationStatus.invalid": "No",
  "moneyIn.enum.ValidationStatus.unknown": "Unknown",
  "moneyIn.enum.ValidationStatus.valid": "Yes",
  "moneyIn.enum.ValueTransferType.none": "None",
  "moneyIn.enum.VoluntaryContributionPlacement.none": "None",
  "moneyIn.enum.VoluntaryContributionType.oneTime": "",
  "moneyIn.enum.VoluntaryContributionType.recurring": "",
  "moneyOut.enum.AccountType.approvedPayables": "Approved payables",
  "moneyOut.enum.AccountType.bankShadow": "Bank shadow",
  "moneyOut.enum.AccountType.convertedHistoricPayments": "Converted historic payments",
  "moneyOut.enum.AccountType.convertedShadow": "Converted shadow",
  "moneyOut.enum.AccountType.externalHandlingShadow": "External handling shadow",
  "moneyOut.enum.AccountType.failedPayments": "Failed payments",
  "moneyOut.enum.AccountType.lifeShadow": "Life shadow",
  "moneyOut.enum.AccountType.moneyInShadow": "Money in shadow",
  "moneyOut.enum.AccountType.none": "None",
  "moneyOut.enum.AccountType.payableElements": "Payable elements",
  "moneyOut.enum.AccountType.paymentRegulationBalance": "Payment regulation balance",
  "moneyOut.enum.AccountType.payments": "Payments",
  "moneyOut.enum.AccountType.pendingPayables": "Pending payables",
  "moneyOut.enum.AccountType.pendingPayments": "Pending payments",
  "moneyOut.enum.AccountType.rounding": "",
  "moneyOut.enum.AccountType.taxBalance": "Tax balance",
  "moneyOut.enum.AccountType.toLife": "To life",
  "moneyOut.enum.AccountType.writeOffShadow": "Write off shadow",
  "moneyOut.enum.AuditLogEventType.create": "",
  "moneyOut.enum.AuditLogEventType.read": "",
  "moneyOut.enum.AuditLogEventType.update": "",
  "moneyOut.enum.BankAccountKind.Iban": "",
  "moneyOut.enum.BankAccountKind.Other": "",
  "moneyOut.enum.BatchStatusType.completed": "Completed",
  "moneyOut.enum.BatchStatusType.created": "Created",
  "moneyOut.enum.BatchStatusType.failed": "Failed",
  "moneyOut.enum.BatchStatusType.started": "Started",
  "moneyOut.enum.BatchStatusType.stopped": "Stopped",
  "moneyOut.enum.BillingChannel.bS": "",
  "moneyOut.enum.BillingFrequency.halfyear": "Half-yearly",
  "moneyOut.enum.BillingFrequency.month": "Monthly",
  "moneyOut.enum.BillingFrequency.quarter": "Quarterly",
  "moneyOut.enum.BillingFrequency.year": "Yearly",
  "moneyOut.enum.BulkDataType.Accounts": "",
  "moneyOut.enum.BulkDataType.BalancePostings": "",
  "moneyOut.enum.BulkDataType.Enums": "",
  "moneyOut.enum.BulkDataType.OpenPostPostings": "",
  "moneyOut.enum.BulkDataType.ParameterValueIntervals": "",
  "moneyOut.enum.BulkDataType.ParameterValues": "",
  "moneyOut.enum.BulkDataType.TariffTemplates": "",
  "moneyOut.enum.BulkDataType.Tenants": "",
  "moneyOut.enum.BulkDataType.WorkPads": "",
  "moneyOut.enum.BusinessType.company": "",
  "moneyOut.enum.BusinessType.person": "",
  "moneyOut.enum.CommandGroupType.advance": "",
  "moneyOut.enum.CommandGroupType.annotation": "",
  "moneyOut.enum.CommandGroupType.calculation": "",
  "moneyOut.enum.CommandGroupType.employerAgreement": "",
  "moneyOut.enum.CommandGroupType.employment": "",
  "moneyOut.enum.CommandGroupType.legalEntity": "",
  "moneyOut.enum.CommandGroupType.moneyIn": "",
  "moneyOut.enum.CommandGroupType.moneyOut": "",
  "moneyOut.enum.CommandGroupType.none": "None",
  "moneyOut.enum.CommandGroupType.policyChange": "",
  "moneyOut.enum.CommandGroupType.posting": "",
  "moneyOut.enum.CommandGroupType.tax": "",
  "moneyOut.enum.CommandGroupType.unitlink": "",
  "moneyOut.enum.CommandType.addAccessGroupAnnotation": "Add access group annotation",
  "moneyOut.enum.CommandType.addPayableStop": "Add payable stop",
  "moneyOut.enum.CommandType.addPaymentChannel": "Add payment channel",
  "moneyOut.enum.CommandType.amendAccessGroupAnnotation": "Amend access group annotation",
  "moneyOut.enum.CommandType.createPaymentReceiver": "Create payment receiver",
  "moneyOut.enum.CommandType.defaultTemplate": "Default template",
  "moneyOut.enum.CommandType.deletePayableStop": "Delete payable stop",
  "moneyOut.enum.CommandType.deletePaymentChannel": "Delete payment channel",
  "moneyOut.enum.CommandType.editPayableStop": "Edit payable stop",
  "moneyOut.enum.CommandType.editPaymentChannel": "Edit payment channel",
  "moneyOut.enum.CommandType.removeAccessGroupAnnotation": "Remove access group annotation",
  "moneyOut.enum.CommandType.setDefaultPaymentChannel": "Set default payment channel",
  "moneyOut.enum.CompanyStatus.none": "None",
  "moneyOut.enum.Component.caseHandler": "",
  "moneyOut.enum.Component.legalEntity": "",
  "moneyOut.enum.Component.life": "",
  "moneyOut.enum.Component.moneyIn": "",
  "moneyOut.enum.Component.moneyOut": "",
  "moneyOut.enum.Component.unitlink": "",
  "moneyOut.enum.ConfigurationEntityType.EnumDefinition": "",
  "moneyOut.enum.ConfigurationEntityType.EnumLiteral": "",
  "moneyOut.enum.ConfigurationEntityType.GlMap": "",
  "moneyOut.enum.ConfigurationEntityType.ParameterDefinition": "",
  "moneyOut.enum.ConfigurationEntityType.ParameterValue": "",
  "moneyOut.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "moneyOut.enum.ConfigurationEntityType.RegisteredTenant": "",
  "moneyOut.enum.ConfigurationEntityType.Template": "",
  "moneyOut.enum.DataSubscriptionRoleType.unspecified": "",
  "moneyOut.enum.EmploymentEndCause.deathOfEmployee": "",
  "moneyOut.enum.EmploymentEndCause.standardEnd": "",
  "moneyOut.enum.ExternalPayloadProcessStatusType.deleted": "Deleted",
  "moneyOut.enum.ExternalPayloadProcessStatusType.processed": "Processed",
  "moneyOut.enum.ExternalPayloadProcessStatusType.registered": "Registered",
  "moneyOut.enum.ExternalPayloadProcessStatusType.rejected": "Rejected",
  "moneyOut.enum.ExternalPayloadProcessStatusType.sent": "Sent",
  "moneyOut.enum.ExternalPayloadProcessStatusType.unsent": "Unsent",
  "moneyOut.enum.ExternalPayloadReceiver.collcalc": "",
  "moneyOut.enum.ExternalPayloadReceiver.datamart2": "",
  "moneyOut.enum.ExternalPayloadReceiver.external": "",
  "moneyOut.enum.ExternalPayloadReceiver.legalentity": "",
  "moneyOut.enum.ExternalPayloadReceiver.life": "",
  "moneyOut.enum.ExternalPayloadReceiver.moneyin": "",
  "moneyOut.enum.ExternalPayloadReceiver.moneyout": "",
  "moneyOut.enum.ExternalPayloadReceiver.unitlink": "",
  "moneyOut.enum.ExternalPayloadType.bulkDataExport": "Bulk data export",
  "moneyOut.enum.ExternalPayloadType.camt53": "camt.053",
  "moneyOut.enum.ExternalPayloadType.camt53Returns": "camt.053 returns",
  "moneyOut.enum.ExternalPayloadType.camt54": "camt.054",
  "moneyOut.enum.ExternalPayloadType.generalLedger": "General ledger",
  "moneyOut.enum.ExternalPayloadType.migration": "Migration",
  "moneyOut.enum.ExternalPayloadType.namingResponse": "",
  "moneyOut.enum.ExternalPayloadType.none": "None",
  "moneyOut.enum.ExternalPayloadType.pain001": "pain.001",
  "moneyOut.enum.ExternalPayloadType.pain002": "pain.002",
  "moneyOut.enum.ExternalPayloadType.testTransactionalIn": "Test transactional in",
  "moneyOut.enum.ExternalPayloadType.testTransactionalOut": "Test transactional out",
  "moneyOut.enum.ExternalPayloadType.testin": "Testin",
  "moneyOut.enum.ExternalPayloadType.testout": "Testout",
  "moneyOut.enum.FPlusCompletionItemTag.deprecated": "",
  "moneyOut.enum.Gender.Female": "Female",
  "moneyOut.enum.Gender.Male": "Male",
  "moneyOut.enum.Gender.Unknown": "Unknown",
  "moneyOut.enum.GlAggregationType.correction": "",
  "moneyOut.enum.GlAggregationType.counter": "",
  "moneyOut.enum.GlAggregationType.manual": "",
  "moneyOut.enum.GlAggregationType.normal": "",
  "moneyOut.enum.LegalEntityRegistrySubscriptionStatus.subscribeInProgress": "Subscribe in progress",
  "moneyOut.enum.LegalEntityRegistrySubscriptionStatus.subscribed": "Subscribed",
  "moneyOut.enum.LegalEntityRegistrySubscriptionStatus.unsubscribeInProgress": "Ubsubscribe in progress",
  "moneyOut.enum.LegalEntityRegistrySubscriptionStatus.unsubscribed": "Unsubscribed",
  "moneyOut.enum.LifeInsuranceEvent.accident": "Accident",
  "moneyOut.enum.LifeInsuranceEvent.criticalIllness": "Critical illness",
  "moneyOut.enum.LifeInsuranceEvent.death": "Death",
  "moneyOut.enum.LifeInsuranceEvent.deathOfRelated": "Death of related",
  "moneyOut.enum.LifeInsuranceEvent.disability": "Disability",
  "moneyOut.enum.LifeInsuranceEvent.divorce": "Divorce",
  "moneyOut.enum.LifeInsuranceEvent.lossOfLicense": "Loss of license",
  "moneyOut.enum.LifeInsuranceEvent.paidUp": "Paid up",
  "moneyOut.enum.LifeInsuranceEvent.premiumHoliday": "Premium holiday",
  "moneyOut.enum.LifeInsuranceEvent.retirement": "Retirement",
  "moneyOut.enum.LifeInsuranceEvent.surrender": "Surender",
  "moneyOut.enum.LifeInsuranceEvent.transferOut": "Transfer out",
  "moneyOut.enum.LifeInsuranceEvent.transferOutDivorce": "Transfer out divorce",
  "moneyOut.enum.LifeInsuranceEvent.voluntaryContinuation": "Voluntary continuation",
  "moneyOut.enum.LogLevel.all": "",
  "moneyOut.enum.LogLevel.debug": "",
  "moneyOut.enum.LogLevel.error": "",
  "moneyOut.enum.LogLevel.info": "",
  "moneyOut.enum.LogLevel.off": "",
  "moneyOut.enum.LogLevel.trace": "",
  "moneyOut.enum.LogLevel.warn": "",
  "moneyOut.enum.MetaAssociationOutput.aggregation": "",
  "moneyOut.enum.MetaAssociationOutput.composition": "",
  "moneyOut.enum.MetaCardinalityOutput.many": "",
  "moneyOut.enum.MetaCardinalityOutput.one": "",
  "moneyOut.enum.OutgoingPaymentType.lumpSum": "Lump sum",
  "moneyOut.enum.OutgoingPaymentType.onAccount": "On account",
  "moneyOut.enum.OutgoingPaymentType.paymentsRefund": "Payments refund",
  "moneyOut.enum.OutgoingPaymentType.recurring": "Recurring",
  "moneyOut.enum.OutgoingPaymentType.recurringTaxFree": "Recurring tax free",
  "moneyOut.enum.OutgoingPaymentType.transit": "Transit",
  "moneyOut.enum.PartnershipType.cohabitant": "",
  "moneyOut.enum.PartnershipType.married": "",
  "moneyOut.enum.PartnershipType.registeredPartnership": "",
  "moneyOut.enum.PayableStatus.approved": "",
  "moneyOut.enum.PayableStatus.cancelled": "",
  "moneyOut.enum.PayableStatus.pending": "",
  "moneyOut.enum.PayableStatus.processed": "",
  "moneyOut.enum.PayableStopType.lumpSum": "Lump sum",
  "moneyOut.enum.PayableStopType.recurring": "Recurring",
  "moneyOut.enum.PayableStopType.returnPayment": "Return payment",
  "moneyOut.enum.PayableStopType.transferOut": "Transfer out",
  "moneyOut.enum.PaymentChannelType.domestic": "Domestic account",
  "moneyOut.enum.PaymentChannelType.international": "Foreign account",
  "moneyOut.enum.PaymentOriginType.employer": "",
  "moneyOut.enum.PaymentOriginType.extrabilling": "",
  "moneyOut.enum.PaymentOriginType.life": "",
  "moneyOut.enum.PaymentOriginType.transfer": "",
  "moneyOut.enum.PaymentOriginType.voluntary": "",
  "moneyOut.enum.PaymentReceiverType.Account": "",
  "moneyOut.enum.PaymentReceiverType.LegalEntity": "",
  "moneyOut.enum.PaymentReceiverType.PaymentSender": "",
  "moneyOut.enum.PaymentStatus.aborted": "Aborted",
  "moneyOut.enum.PaymentStatus.completed": "Completed",
  "moneyOut.enum.PaymentStatus.failed": "Failed",
  "moneyOut.enum.PaymentStatus.none": "None",
  "moneyOut.enum.PaymentStatus.ready": "Ready",
  "moneyOut.enum.PaymentStatus.sent": "Sent",
  "moneyOut.enum.PaymentStopType.lumpSum": "Lump sum",
  "moneyOut.enum.PaymentStopType.recurring": "Recurring",
  "moneyOut.enum.PaymentStopType.returnPayment": "Return payment",
  "moneyOut.enum.PaymentStopType.transferOut": "Transfer out",
  "moneyOut.enum.PostingTable.BP": "",
  "moneyOut.enum.PostingTable.OPP": "",
  "moneyOut.enum.PostingType.fromPaymentRegulationLumpSum": "From payment regulation lump sum",
  "moneyOut.enum.PostingType.fromPaymentRegulationRecurring": "From payment regulation recurring",
  "moneyOut.enum.PostingType.glRounding": "General ledger rounding",
  "moneyOut.enum.PostingType.glRoundingExcluded": "General ledger rounding excluded",
  "moneyOut.enum.PostingType.netPaymentRegulation": "Net payment regulation",
  "moneyOut.enum.PostingType.none": "None",
  "moneyOut.enum.PostingType.onAccountPayment": "On account payment",
  "moneyOut.enum.PostingType.payable": "Payable",
  "moneyOut.enum.PostingType.paymentRegulationLumpSum": "Payment regulation lump sum",
  "moneyOut.enum.PostingType.paymentRegulationRecurring": "Payment regulation recurring",
  "moneyOut.enum.PostingType.paymentRegulationTaxFree": "Payment regulation tax free",
  "moneyOut.enum.PostingType.returnedOnAccountPayment": "Returned on account payment",
  "moneyOut.enum.PostingType.returnedOnAccountPaymentCost": "Returned on account payment cost",
  "moneyOut.enum.PostingType.returnedTaxFreePayment": "Returned tax free payment",
  "moneyOut.enum.PostingType.returnedTaxFreePaymentCost": "Returned tax free payment cost",
  "moneyOut.enum.PostingType.taxFreePayable": "Tax free payable",
  "moneyOut.enum.PostingType.taxFreePayment": "Tax free payment",
  "moneyOut.enum.PostingType.transitPayable": "Transit payable",
  "moneyOut.enum.PostingType.transitPayment": "Transit payment",
  "moneyOut.enum.ProfileType.individualProfile": "",
  "moneyOut.enum.ProfileType.lifeCycleProfile": "",
  "moneyOut.enum.RegistrySubscriptionLevel.fullRegistrySubscription": "Full registry subscription",
  "moneyOut.enum.RegistrySubscriptionLevel.none": "None",
  "moneyOut.enum.RegistrySubscriptionLevel.onDemand": "On demand",
  "moneyOut.enum.RegistrySubscriptionRoleType.unspecified": "",
  "moneyOut.enum.ReportType.none": "None",
  "moneyOut.enum.ReportingEventType.cancelled": "",
  "moneyOut.enum.ReportingEventType.newReport": "",
  "moneyOut.enum.ReportingEventType.reported": "",
  "moneyOut.enum.ReportingEventType.update": "",
  "moneyOut.enum.TestBatchSpecificationType.faulty": "",
  "moneyOut.enum.TestBatchSpecificationType.noop": "",
  "moneyOut.enum.TestBatchSpecificationType.normal": "",
  "moneyOut.enum.VoluntaryContributionPlacement.none": "None",
  "moneyOut.enum.VoluntaryContributionType.oneTime": "",
  "moneyOut.enum.VoluntaryContributionType.recurring": "",
  "unitLink.enum.AccountType.correctionShadow": "Correction shadow",
  "unitLink.enum.AccountType.cost": "Cost",
  "unitLink.enum.AccountType.dividendShadow": "Dividend shadow",
  "unitLink.enum.AccountType.fromLifeShadow": "From life shadow",
  "unitLink.enum.AccountType.fund": "Fund",
  "unitLink.enum.AccountType.fundMergeShadow": "Fund merge shadow",
  "unitLink.enum.AccountType.fundReserved": "Fund reserved",
  "unitLink.enum.AccountType.interim": "Interim",
  "unitLink.enum.AccountType.invested": "Invested",
  "unitLink.enum.AccountType.investment": "Investment",
  "unitLink.enum.AccountType.kickbackShadow": "Kickback shadow",
  "unitLink.enum.AccountType.lifeAutoEmptyReturn": "Life auto empty return",
  "unitLink.enum.AccountType.lifeBalanceUpdate": "Life balance update",
  "unitLink.enum.AccountType.lifeClosedPortfolio": "Life closed portfolio",
  "unitLink.enum.AccountType.lifeIn": "Life in",
  "unitLink.enum.AccountType.lifeInCounter": "Life in counter",
  "unitLink.enum.AccountType.none": "None",
  "unitLink.enum.AccountType.reservedUnits": "Reserved units",
  "unitLink.enum.AccountType.rounding": "",
  "unitLink.enum.AccountType.toLifeAutoEmptyReturn": "To life auto empty return",
  "unitLink.enum.AccountType.toLifeAutoEmptyReturnShadow": "To life auto empty return shadow",
  "unitLink.enum.AccountType.toLifeBalanceUpdate": "To life balance update",
  "unitLink.enum.AccountType.toLifeBalanceUpdateShadow": "To life balance update shadow",
  "unitLink.enum.AccountType.toLifeClosedPortfolio": "To life closed portfolio",
  "unitLink.enum.AccountType.toLifeClosedPortfolioShadow": "To life closed portfolio shadow",
  "unitLink.enum.AccountType.trade": "Trade",
  "unitLink.enum.AccountType.tradeCycle": "Trade cycle",
  "unitLink.enum.AccountType.tradeCycleAmount": "Trade cycle amount",
  "unitLink.enum.AccountType.tradeCycleUnits": "Trade cycle units",
  "unitLink.enum.AccountType.units": "Units",
  "unitLink.enum.BatchStatusType.completed": "Completed",
  "unitLink.enum.BatchStatusType.created": "Created",
  "unitLink.enum.BatchStatusType.failed": "Failed",
  "unitLink.enum.BatchStatusType.started": "Started",
  "unitLink.enum.BatchStatusType.stopped": "Stopped",
  "unitLink.enum.BulkDataType.Accounts": "",
  "unitLink.enum.BulkDataType.BalancePostings": "",
  "unitLink.enum.BulkDataType.Enums": "",
  "unitLink.enum.BulkDataType.OpenPostPostings": "",
  "unitLink.enum.BulkDataType.ParameterValueIntervals": "",
  "unitLink.enum.BulkDataType.ParameterValues": "",
  "unitLink.enum.BulkDataType.TariffTemplates": "",
  "unitLink.enum.BulkDataType.Tenants": "",
  "unitLink.enum.BulkDataType.WorkPads": "",
  "unitLink.enum.BusinessType.company": "",
  "unitLink.enum.BusinessType.person": "",
  "unitLink.enum.CommandGroupType.advance": "Advance",
  "unitLink.enum.CommandGroupType.annotation": "Annotation",
  "unitLink.enum.CommandGroupType.calculation": "Calculation",
  "unitLink.enum.CommandGroupType.employerAgreement": "Employer agreement",
  "unitLink.enum.CommandGroupType.employment": "Employment",
  "unitLink.enum.CommandGroupType.legalEntity": "Legal entity",
  "unitLink.enum.CommandGroupType.moneyIn": "Money in",
  "unitLink.enum.CommandGroupType.moneyOut": "Money out",
  "unitLink.enum.CommandGroupType.none": "None",
  "unitLink.enum.CommandGroupType.policyChange": "Policy change",
  "unitLink.enum.CommandGroupType.posting": "Posting",
  "unitLink.enum.CommandGroupType.tax": "Tax",
  "unitLink.enum.CommandGroupType.unitlink": "Unitlink",
  "unitLink.enum.CommandType.addAccessGroupAnnotation": "Add access group annotation",
  "unitLink.enum.CommandType.addFundDividend": "Add fund dividend",
  "unitLink.enum.CommandType.addFundMerge": "Add fund merge",
  "unitLink.enum.CommandType.addPortfolioBalancePostings": "Add portfolio balance postings",
  "unitLink.enum.CommandType.amendAccessGroupAnnotation": "Amend access group annotation",
  "unitLink.enum.CommandType.autoEmptyMove": "",
  "unitLink.enum.CommandType.changeFund": "Change fund",
  "unitLink.enum.CommandType.closeSubPortfolio": "Close sub portfolio",
  "unitLink.enum.CommandType.defaultTemplate": "Default template",
  "unitLink.enum.CommandType.editPortfolio": "Edit portfolio",
  "unitLink.enum.CommandType.endEmployment": "End employment",
  "unitLink.enum.CommandType.investmentSpec": "Investment specification",
  "unitLink.enum.CommandType.investmentTrade": "Investment trade",
  "unitLink.enum.CommandType.moveSubPortfolio": "Move sub portfolio",
  "unitLink.enum.CommandType.newFund": "New fund",
  "unitLink.enum.CommandType.newSubPortfolios": "New sub portfolios",
  "unitLink.enum.CommandType.portfolioCorrection": "Portfolio correction",
  "unitLink.enum.CommandType.rebalance": "Rebalance",
  "unitLink.enum.CommandType.removeAccessGroupAnnotation": "Remove access group annotation",
  "unitLink.enum.CommandType.revertCloseSubPortfolio": "Revert close sub portfolio",
  "unitLink.enum.CommandType.revertEndEmployment": "Revert end employment",
  "unitLink.enum.CommandType.revertMoveSubPortfolio": "Revert move sub portfolio",
  "unitLink.enum.CommandType.revertNewSubPortfolios": "Revert new sub portfolios",
  "unitLink.enum.CommandType.revertStartEmployment": "Revert start employment",
  "unitLink.enum.CommandType.setPortfolioOwner": "Set portfolio owner",
  "unitLink.enum.CommandType.startEmployment": "Start employment",
  "unitLink.enum.CommandType.switchSubPortfolioCommand": "Switch sub portfolio command",
  "unitLink.enum.CommandType.switchSubPortfolioGroupCommand": "Switch sub portfolio group command",
  "unitLink.enum.CommandType.switchTrade": "Switch trade",
  "unitLink.enum.CommandType.tradeExecution": "Trade execution",
  "unitLink.enum.CommandType.unitlinkConversion": "Unitlink conversion",
  "unitLink.enum.ConfigurationEntityType.EnumDefinition": "",
  "unitLink.enum.ConfigurationEntityType.EnumLiteral": "",
  "unitLink.enum.ConfigurationEntityType.GlMap": "",
  "unitLink.enum.ConfigurationEntityType.ParameterDefinition": "",
  "unitLink.enum.ConfigurationEntityType.ParameterValue": "",
  "unitLink.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "unitLink.enum.ConfigurationEntityType.RegisteredTenant": "",
  "unitLink.enum.ConfigurationEntityType.Template": "",
  "unitLink.enum.DataSubscriptionRoleType.unspecified": "",
  "unitLink.enum.EditType.update": "",
  "unitLink.enum.ExternalPayloadProcessStatusType.deleted": "Deleted",
  "unitLink.enum.ExternalPayloadProcessStatusType.processed": "Processed",
  "unitLink.enum.ExternalPayloadProcessStatusType.registered": "Registered",
  "unitLink.enum.ExternalPayloadProcessStatusType.rejected": "Rejected",
  "unitLink.enum.ExternalPayloadProcessStatusType.sent": "Sent",
  "unitLink.enum.ExternalPayloadProcessStatusType.unsent": "Unsent",
  "unitLink.enum.ExternalPayloadReceiver.collcalc": "",
  "unitLink.enum.ExternalPayloadReceiver.datamart2": "",
  "unitLink.enum.ExternalPayloadReceiver.external": "",
  "unitLink.enum.ExternalPayloadReceiver.legalentity": "",
  "unitLink.enum.ExternalPayloadReceiver.life": "",
  "unitLink.enum.ExternalPayloadReceiver.moneyin": "",
  "unitLink.enum.ExternalPayloadReceiver.moneyout": "",
  "unitLink.enum.ExternalPayloadReceiver.unitlink": "",
  "unitLink.enum.ExternalPayloadType.acknowledgements": "Acknowledgements",
  "unitLink.enum.ExternalPayloadType.bulkDataExport": "Bulk data export",
  "unitLink.enum.ExternalPayloadType.camt53": "camt.053",
  "unitLink.enum.ExternalPayloadType.camt53Returns": "camt.053 returns",
  "unitLink.enum.ExternalPayloadType.camt54": "camt.054",
  "unitLink.enum.ExternalPayloadType.fundPrices": "Fund prices",
  "unitLink.enum.ExternalPayloadType.generalLedger": "General ledger",
  "unitLink.enum.ExternalPayloadType.migration": "Migration",
  "unitLink.enum.ExternalPayloadType.namingResponse": "",
  "unitLink.enum.ExternalPayloadType.none": "None",
  "unitLink.enum.ExternalPayloadType.orderConfirmation": "Order confirmation",
  "unitLink.enum.ExternalPayloadType.pain001": "pain.001",
  "unitLink.enum.ExternalPayloadType.pain002": "pain.002",
  "unitLink.enum.ExternalPayloadType.testTransactionalIn": "Test transactional in",
  "unitLink.enum.ExternalPayloadType.testTransactionalOut": "Test transactional out",
  "unitLink.enum.ExternalPayloadType.testin": "Testin",
  "unitLink.enum.ExternalPayloadType.testout": "Testout",
  "unitLink.enum.ExternalPayloadType.tradeOrder": "Trade order",
  "unitLink.enum.ExternalPayloadType.unitlinkConversion": "Unitlink conversion",
  "unitLink.enum.FPlusCompletionItemTag.deprecated": "",
  "unitLink.enum.FundRiskLevel.none": "None",
  "unitLink.enum.Gender.Female": "",
  "unitLink.enum.Gender.Male": "",
  "unitLink.enum.Gender.Unknown": "",
  "unitLink.enum.GlAggregationType.correction": "",
  "unitLink.enum.GlAggregationType.counter": "",
  "unitLink.enum.GlAggregationType.manual": "",
  "unitLink.enum.GlAggregationType.normal": "",
  "unitLink.enum.InvestmentAllocation.active": "",
  "unitLink.enum.InvestmentAllocation.profile": "",
  "unitLink.enum.LogLevel.all": "",
  "unitLink.enum.LogLevel.debug": "",
  "unitLink.enum.LogLevel.error": "",
  "unitLink.enum.LogLevel.info": "",
  "unitLink.enum.LogLevel.off": "",
  "unitLink.enum.LogLevel.trace": "",
  "unitLink.enum.LogLevel.warn": "",
  "unitLink.enum.MetaAssociationOutput.aggregation": "",
  "unitLink.enum.MetaAssociationOutput.composition": "",
  "unitLink.enum.MetaCardinalityOutput.many": "",
  "unitLink.enum.MetaCardinalityOutput.one": "",
  "unitLink.enum.PortfolioStatementPeriod.days": "",
  "unitLink.enum.PortfolioStatementPeriod.months": "",
  "unitLink.enum.PortfolioStatementPeriod.years": "",
  "unitLink.enum.PostingTable.BP": "",
  "unitLink.enum.PostingTable.OPP": "",
  "unitLink.enum.PostingType.autoEmptyMove": "",
  "unitLink.enum.PostingType.autoEmptyMoveFromLife": "",
  "unitLink.enum.PostingType.autoEmptyReturn": "Auto empty return",
  "unitLink.enum.PostingType.balance": "Balance",
  "unitLink.enum.PostingType.balanceUpdateFromLife": "Balance update from life",
  "unitLink.enum.PostingType.closeSubPortfolio": "Close sub portfolio",
  "unitLink.enum.PostingType.deInvested": "De-invested",
  "unitLink.enum.PostingType.deltaMoveSubPortfolio": "Delta move sub-portfolio",
  "unitLink.enum.PostingType.dividend": "Dividend",
  "unitLink.enum.PostingType.endEmploymentFromLife": "End employment from life",
  "unitLink.enum.PostingType.fundCost": "Fund cost",
  "unitLink.enum.PostingType.fundMerge": "Fund merge",
  "unitLink.enum.PostingType.glRounding": "General ledger rounding",
  "unitLink.enum.PostingType.glRoundingExcluded": "General ledger rounding excluded",
  "unitLink.enum.PostingType.invested": "Invested",
  "unitLink.enum.PostingType.investedDiff": "Invested diff",
  "unitLink.enum.PostingType.investedInternal": "Invested internal",
  "unitLink.enum.PostingType.investmentFromLife": "Investment from life",
  "unitLink.enum.PostingType.kickback": "Kickback",
  "unitLink.enum.PostingType.moveSubPortfolio": "Move sub portfolio",
  "unitLink.enum.PostingType.moveSubPortfolioFromLife": "Move sub portfolio from life",
  "unitLink.enum.PostingType.newSubPortfolio": "New sub portfolio",
  "unitLink.enum.PostingType.newSubPortfolioFromLife": "New sub portfolio from life",
  "unitLink.enum.PostingType.none": "None",
  "unitLink.enum.PostingType.revertBalanceUpdateFromLife": "Revert balance update from life",
  "unitLink.enum.PostingType.revertCloseSubPortfolio": "Revert close sub portfolio",
  "unitLink.enum.PostingType.revertEndEmploymentFromLife": "Revert end employment from life",
  "unitLink.enum.PostingType.revertMoveSubPortfolioFromLife": "Revert move sub portfolio from life",
  "unitLink.enum.PostingType.revertNewSubPortfolioFromLife": "Revert new sub portfolio from life",
  "unitLink.enum.PostingType.revertStartEmploymentFromLife": "Revert start employment from life",
  "unitLink.enum.PostingType.startEmploymentFromLife": "Start employment from life",
  "unitLink.enum.PostingType.subPortfolioMove": "Move sub portfolio",
  "unitLink.enum.PostingType.tradeAmount": "Trade amount",
  "unitLink.enum.PostingType.tradeAmountCorrection": "Trade amount correction",
  "unitLink.enum.PostingType.tradeAmountDividend": "Trade amount dividend",
  "unitLink.enum.PostingType.tradeAmountFundCost": "Trade amount fund cost",
  "unitLink.enum.PostingType.tradeCost": "Trade cost",
  "unitLink.enum.PostingType.tradeUnit": "Trade unit",
  "unitLink.enum.PostingType.tradeUnitCorrection": "Trade unit correction",
  "unitLink.enum.PostingType.yield": "Yield",
  "unitLink.enum.ProfileType.individualProfile": "Individual profile",
  "unitLink.enum.ProfileType.lifeCycleProfile": "Life cycle profile",
  "unitLink.enum.PrognosisAssetClass.None": "None",
  "unitLink.enum.ReportType.none": "None",
  "unitLink.enum.ReportingEventType.cancelled": "",
  "unitLink.enum.ReportingEventType.newReport": "",
  "unitLink.enum.ReportingEventType.reported": "",
  "unitLink.enum.ReportingEventType.update": "",
  "unitLink.enum.SwitchCommandType.paymentAndSavingsDistribution": "Payment and savings distribution",
  "unitLink.enum.SwitchCommandType.paymentDistribution": "Payment distribution",
  "unitLink.enum.SwitchCommandType.savingsDistribution": "Savings distribution",
  "unitLink.enum.TestBatchSpecificationType.faulty": "",
  "unitLink.enum.TestBatchSpecificationType.noop": "",
  "unitLink.enum.TestBatchSpecificationType.normal": "",
  "unitLink.enum.TradeCycleStatusType.aggregated": "",
  "unitLink.enum.TradeCycleStatusType.closed": "",
  "unitLink.enum.TradeCycleStatusType.completed": "",
  "unitLink.enum.TradeCycleStatusType.completelyAcknowledged": "",
  "unitLink.enum.TradeCycleStatusType.completelySent": "",
  "unitLink.enum.TradeCycleStatusType.invested": "",
  "unitLink.enum.TradeCycleStatusType.partlyAcknowledged": "",
  "unitLink.enum.TradeCycleStatusType.partlySent": "",
  "unitLink.enum.TradeCycleStatusType.somePricesReceived": "",
  "unitLink.enum.TradeCycleStatusType.started": "",
  "unitLink.enum.TradeCycleType.none": "None",
})

export const enConfiguredEnums = defineTranslations<
  ExtendableTranslationEnumRecords<{
    moneyIn: MoneyInEnumRecord
  }>
>()({
  "moneyIn.enum.InvoiceBundlingPenaltyType.lateDeliveryPenalty": "Late delivery",
})
